import o1, { loader as j1 } from "@monaco-editor/react";
import { jsx as e, jsxs as c, Fragment as T } from "react/jsx-runtime";
import f from "classnames";
import B1, { useMemo as B, createElement as O1, createContext as W1, useRef as Y, useContext as G1, useEffect as v1, useState as y, forwardRef as J1 } from "react";
import U1, { createPortal as Y1 } from "react-dom";
import K1 from "react-markdown";
import { Prism as q1 } from "react-syntax-highlighter";
import Q1, { Prism as z1 } from "prism-react-renderer";
import X1 from "mitt";
import ee from "remark-gfm";
import { useMount as te } from "ahooks";
import ne from "rehype-raw";
import oe from "remark-math";
import ce from "rehype-katex";
import D1 from "react-diff-viewer-continued";
import se from "react-draggable";
import le from "copy-to-clipboard";
j1.config({
  paths: {
    vs: "https://python2fun.oss-cn-beijing.aliyuncs.com/@quark-app/learn/vs"
  }
});
const re = "_button_f3qfq_1", ie = "_outlined_f3qfq_20", ae = "_filled_f3qfq_24", de = "_blue_f3qfq_28", he = "_green_f3qfq_46", ue = "_red_f3qfq_64", _e = "_gray_f3qfq_82", k1 = {
  button: re,
  outlined: ie,
  filled: ae,
  blue: de,
  green: he,
  red: ue,
  gray: _e
}, $ = ({
  children: n,
  width: t,
  color: o = "blue",
  variant: s = "outlined",
  className: r,
  style: l,
  disabled: h,
  ...i
}) => /* @__PURE__ */ e(
  "button",
  {
    ...i,
    disabled: h,
    style: {
      ...l,
      width: t
    },
    className: f(
      k1.button,
      k1[o],
      k1[s],
      r
    ),
    children: n
  }
), me = "_alert_15pao_1", pe = "_success_15pao_10", Ce = "_icon_15pao_13", ge = "_body_15pao_29", fe = "_title_15pao_29", ve = "_error_15pao_32", ye = "_content_15pao_73", e1 = {
  alert: me,
  success: pe,
  icon: Ce,
  body: ge,
  title: fe,
  error: ve,
  content: ye
}, S1 = ({ title: n, variant: t, style: o, children: s, className: r }) => /* @__PURE__ */ c(
  "div",
  {
    className: f(e1.alert, e1[t], r),
    style: o,
    children: [
      /* @__PURE__ */ e("div", { className: e1.icon }),
      /* @__PURE__ */ c("div", { className: e1.body, children: [
        /* @__PURE__ */ e("div", { className: e1.title, children: n }),
        /* @__PURE__ */ e("div", { className: e1.content, children: s })
      ] })
    ]
  }
), we = "_box_1sehn_1", be = "_checkable_1sehn_18", Ne = "_check_1sehn_18", xe = "_cross_1sehn_41", ke = "_sortable_1sehn_66", Le = "_primary_1sehn_85", $e = "_success_1sehn_95", Me = "_error_1sehn_105", Ve = "_description_1sehn_116", t1 = {
  box: we,
  checkable: be,
  check: Ne,
  cross: xe,
  sortable: ke,
  primary: Le,
  success: $e,
  error: Me,
  description: Ve
}, u2 = ({
  variant: n,
  optionType: t,
  description: o,
  className: s,
  children: r,
  ...l
}) => {
  const h = () => {
    if (!n)
      return null;
    if (n === "primary" || n === "success")
      return /* @__PURE__ */ e("div", { className: t1.check });
    if (n === "error")
      return /* @__PURE__ */ e("div", { className: t1.cross });
  }, i = () => t === "checkable" ? /* @__PURE__ */ e("div", { className: t1.checkable, children: h() }) : null, a = () => t === "sortable" ? /* @__PURE__ */ c("div", { className: t1.sortable, children: [
    /* @__PURE__ */ e("span", {}),
    /* @__PURE__ */ e("span", {}),
    /* @__PURE__ */ e("span", {})
  ] }) : null, d = () => o ? n === "success" ? /* @__PURE__ */ e(S1, { title: "答案正确", variant: "success", children: o }) : n === "error" ? /* @__PURE__ */ e(S1, { title: "答案错误", variant: "error", children: o }) : null : null;
  return /* @__PURE__ */ c(T, { children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: f(t1.box, t1[n || ""], s),
        ...l,
        children: [
          i(),
          r,
          a()
        ]
      }
    ),
    d()
  ] });
};
var i1 = {}, r1 = U1;
if (process.env.NODE_ENV === "production")
  i1.createRoot = r1.createRoot, i1.hydrateRoot = r1.hydrateRoot;
else {
  var p1 = r1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  i1.createRoot = function(n, t) {
    p1.usingClientEntryPoint = !0;
    try {
      return r1.createRoot(n, t);
    } finally {
      p1.usingClientEntryPoint = !1;
    }
  }, i1.hydrateRoot = function(n, t, o) {
    p1.usingClientEntryPoint = !0;
    try {
      return r1.hydrateRoot(n, t, o);
    } finally {
      p1.usingClientEntryPoint = !1;
    }
  };
}
const He = "_notification_6cddi_9", Be = "_icon_6cddi_25", Ie = "_topCenter_6cddi_36", Ze = "_bottomCenter_6cddi_40", qe = "_success_6cddi_44", De = "_error_6cddi_63", C1 = {
  notification: He,
  "slide-top": "_slide-top_6cddi_1",
  icon: Be,
  topCenter: Ie,
  bottomCenter: Ze,
  success: qe,
  error: De
}, A = ({
  variant: n,
  position: t = "bottomCenter",
  message: o,
  offset: s = 120,
  width: r = 637
}) => {
  const l = B(() => {
    const h = {
      width: r,
      marginLeft: 0 - r / 2
    };
    return t === "topCenter" && (h.top = s || 0), t === "bottomCenter" && (h.bottom = s || 0), h;
  }, [t, s, r]);
  return /* @__PURE__ */ c(
    "div",
    {
      className: f(
        C1.notification,
        C1[n],
        C1[t]
      ),
      style: l,
      children: [
        /* @__PURE__ */ e("div", { className: C1.icon }),
        /* @__PURE__ */ e("span", { children: o })
      ]
    }
  );
};
let n1 = null, a1 = null, T1 = 0;
A.dispose = () => {
  if (n1 && a1)
    try {
      a1.unmount(), document.body.removeChild(n1);
    } catch {
    } finally {
      a1 = null, n1 = null;
    }
};
A.show = ({ duration: n = 0, ...t }) => {
  window.clearTimeout(T1), n1 = document.createElement("div"), document.body.appendChild(n1), a1 = i1.createRoot(n1), a1.render(/* @__PURE__ */ e(A, { ...t })), n > 0 && (T1 = window.setTimeout(A.dispose, n));
};
A.success = (n, t) => {
  A.show({
    variant: "success",
    message: n,
    duration: 0,
    ...t
  });
};
A.error = (n, t) => {
  A.show({
    variant: "error",
    message: n,
    duration: 0,
    ...t
  });
};
const Se = "_pageFooter_yw3dv_1", Te = "_spaceBetween_yw3dv_16", Ee = "_center_yw3dv_20", L1 = {
  pageFooter: Se,
  spaceBetween: Te,
  center: Ee
}, _2 = ({
  className: n,
  children: t
}) => {
  const o = B(() => B1.Children.count(t), [t]);
  return /* @__PURE__ */ e(
    "div",
    {
      className: f(
        n,
        L1.pageFooter,
        o > 1 ? L1.spaceBetween : L1.center
      ),
      children: /* @__PURE__ */ e("div", { className: "container", children: t })
    }
  );
}, Re = "_progressBar_mimxx_1", ze = "_bar_mimxx_8", Fe = "_indicator_mimxx_30", Ae = "_hide_mimxx_42", g1 = {
  progressBar: Re,
  bar: ze,
  indicator: Fe,
  hide: Ae
}, m2 = ({
  current: n,
  total: t,
  indicator: o,
  className: s,
  onChange: r,
  ...l
}) => {
  const h = B(() => {
    const a = Math.ceil(n / t * 100);
    return a === 0 ? 0 : a < 2 ? 2 : a;
  }, [n, t]), i = () => o ? Array.from({ length: t - 1 }).map((a, d) => /* @__PURE__ */ e(
    "div",
    {
      className: f(
        g1.indicator,
        d + 1 > n && g1.hide
      ),
      style: { left: Math.ceil((d + 1) / t * 100) + "%" },
      onClick: () => r == null ? void 0 : r(d)
    },
    d
  )) : null;
  return /* @__PURE__ */ c("div", { className: f(g1.progressBar, s), ...l, children: [
    /* @__PURE__ */ e("div", { className: g1.bar, style: { width: h + "%" } }),
    i()
  ] });
}, Pe = "_selectList_t325b_1", je = "_row_t325b_1", Oe = "_column_t325b_6", We = "_sampleOption_t325b_12", Ge = "_primary_t325b_24", Je = "_success_t325b_28", Ue = "_error_t325b_32", d1 = {
  selectList: Pe,
  row: je,
  column: Oe,
  sampleOption: We,
  primary: Ge,
  success: Je,
  error: Ue
}, Ye = ({ text: n, variant: t, onClick: o }) => /* @__PURE__ */ e(
  "div",
  {
    className: f(d1.sampleOption, t && d1[t]),
    onClick: () => o == null ? void 0 : o(n),
    children: n
  }
), Ke = ({
  children: n,
  options: t,
  answer: o,
  value: s,
  stage: r = "blank",
  onChange: l
}) => {
  const h = () => n ? B1.Children.map(n, (i) => {
    const a = i.props, d = () => {
      if (r === "blank")
        return null;
      if (s === a.value) {
        if (r === "selected")
          return "primary";
        if (r === "submitted")
          return s === o ? "success" : "error";
      }
      return null;
    };
    return B1.cloneElement(i, {
      onClick: () => {
        r !== "submitted" && (l == null || l(a.value));
      },
      variant: d(),
      ...i.props
    });
  }) : t == null ? void 0 : t.map((i) => {
    const a = () => {
      if (r === "blank")
        return null;
      if (s === i.text) {
        if (r === "selected")
          return "primary";
        if (r === "submitted")
          return s === o ? "success" : "error";
      }
      return null;
    };
    return /* @__PURE__ */ O1(
      Ye,
      {
        ...i,
        key: i.key,
        onClick: (d) => {
          r !== "submitted" && (l == null || l(d));
        },
        variant: a()
      }
    );
  });
  return /* @__PURE__ */ e(
    "div",
    {
      className: f(
        "container",
        d1.selectList,
        n ? d1.column : d1.row
      ),
      children: h()
    }
  );
};
const E1 = {
  'pre[class*="language-"]': {
    color: "#d4d4d4",
    fontSize: "16px",
    textShadow: "none",
    fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
    direction: "ltr",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto",
    background: "#1e1e1e",
    borderRadius: "8px"
  },
  'code[class*="language-"]': {
    color: "#d4d4d4",
    fontSize: "16px",
    textShadow: "none",
    fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace',
    direction: "ltr",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    borderRadius: "8px"
  },
  'pre[class*="language-"]::selection': {
    textShadow: "none",
    background: "#264F78"
  },
  'code[class*="language-"]::selection': {
    textShadow: "none",
    background: "#264F78"
  },
  'pre[class*="language-"] *::selection': {
    textShadow: "none",
    background: "#264F78"
  },
  'code[class*="language-"] *::selection': {
    textShadow: "none",
    background: "#264F78"
  },
  ':not(pre) > code[class*="language-"]': {
    padding: ".1em .3em",
    borderRadius: ".3em",
    color: "#db4c69",
    background: "#1e1e1e"
  },
  ".namespace": {
    Opacity: ".7"
  },
  "doctype.doctype-tag": {
    color: "#569CD6"
  },
  "doctype.name": {
    color: "#9cdcfe"
  },
  comment: {
    color: "#6a9955"
  },
  prolog: {
    color: "#6a9955"
  },
  punctuation: {
    color: "#d4d4d4"
  },
  ".language-html .language-css .token.punctuation": {
    color: "#d4d4d4"
  },
  ".language-html .language-javascript .token.punctuation": {
    color: "#d4d4d4"
  },
  property: {
    color: "#9cdcfe"
  },
  tag: {
    color: "#569cd6"
  },
  boolean: {
    color: "#569cd6"
  },
  number: {
    color: "#b5cea8"
  },
  constant: {
    color: "#9cdcfe"
  },
  symbol: {
    color: "#b5cea8"
  },
  inserted: {
    color: "#b5cea8"
  },
  unit: {
    color: "#b5cea8"
  },
  selector: {
    color: "#d7ba7d"
  },
  "attr-name": {
    color: "#9cdcfe"
  },
  string: {
    color: "#ce9178"
  },
  char: {
    color: "#ce9178"
  },
  builtin: {
    color: "#ce9178"
  },
  deleted: {
    color: "#ce9178"
  },
  ".language-css .token.string.url": {
    textDecoration: "underline"
  },
  operator: {
    color: "#d4d4d4"
  },
  entity: {
    color: "#569cd6"
  },
  "operator.arrow": {
    color: "#569CD6"
  },
  atrule: {
    color: "#ce9178"
  },
  "atrule.rule": {
    color: "#c586c0"
  },
  "atrule.url": {
    color: "#9cdcfe"
  },
  "atrule.url.function": {
    color: "#dcdcaa"
  },
  "atrule.url.punctuation": {
    color: "#d4d4d4"
  },
  keyword: {
    color: "#569CD6"
  },
  "keyword.module": {
    color: "#c586c0"
  },
  "keyword.control-flow": {
    color: "#c586c0"
  },
  function: {
    color: "#dcdcaa"
  },
  "function.maybe-class-name": {
    color: "#dcdcaa"
  },
  regex: {
    color: "#d16969"
  },
  important: {
    color: "#569cd6"
  },
  italic: {
    fontStyle: "italic"
  },
  "class-name": {
    color: "#4ec9b0"
  },
  "maybe-class-name": {
    color: "#4ec9b0"
  },
  console: {
    color: "#9cdcfe"
  },
  parameter: {
    color: "#9cdcfe"
  },
  interpolation: {
    color: "#9cdcfe"
  },
  "punctuation.interpolation-punctuation": {
    color: "#569cd6"
  },
  variable: {
    color: "#9cdcfe"
  },
  "imports.maybe-class-name": {
    color: "#9cdcfe"
  },
  "exports.maybe-class-name": {
    color: "#9cdcfe"
  },
  escape: {
    color: "#d7ba7d"
  },
  "tag.punctuation": {
    color: "#808080"
  },
  cdata: {
    color: "#808080"
  },
  "attr-value": {
    color: "#ce9178"
  },
  "attr-value.punctuation": {
    color: "#ce9178"
  },
  "attr-value.punctuation.attr-equals": {
    color: "#d4d4d4"
  },
  namespace: {
    color: "#4ec9b0"
  },
  'pre[class*="language-javascript"]': {
    color: "#9cdcfe"
  },
  'code[class*="language-javascript"]': {
    color: "#9cdcfe"
  },
  'pre[class*="language-jsx"]': {
    color: "#9cdcfe"
  },
  'code[class*="language-jsx"]': {
    color: "#9cdcfe"
  },
  'pre[class*="language-typescript"]': {
    color: "#9cdcfe"
  },
  'code[class*="language-typescript"]': {
    color: "#9cdcfe"
  },
  'pre[class*="language-tsx"]': {
    color: "#9cdcfe"
  },
  'code[class*="language-tsx"]': {
    color: "#9cdcfe"
  },
  'pre[class*="language-css"]': {
    color: "#ce9178"
  },
  'code[class*="language-css"]': {
    color: "#ce9178"
  },
  'pre[class*="language-html"]': {
    color: "#d4d4d4"
  },
  'code[class*="language-html"]': {
    color: "#d4d4d4"
  },
  ".language-regex .token.anchor": {
    color: "#dcdcaa"
  },
  ".language-html .token.punctuation": {
    color: "#808080"
  },
  'pre[class*="language-"] > code[class*="language-"]': {
    position: "relative",
    zIndex: "1"
  },
  ".line-highlight.line-highlight": {
    background: "#f7ebc6",
    boxShadow: "inset 5px 0 0 #f7d87c",
    zIndex: "0"
  }
}, Qe = {
  plain: {
    color: "#393A34"
  },
  styles: [
    {
      types: ["comment", "prolog", "doctype", "cdata"],
      style: {
        color: "#999988",
        fontStyle: "italic"
      }
    },
    {
      types: ["namespace"],
      style: {
        opacity: 0.7
      }
    },
    {
      types: ["string", "attr-value"],
      style: {
        color: "#e3116c"
      }
    },
    {
      types: ["punctuation", "operator"],
      style: {
        color: "#393A34"
      }
    },
    {
      types: [
        "entity",
        "url",
        "symbol",
        "number",
        "boolean",
        "variable",
        "constant",
        "property",
        "regex",
        "inserted"
      ],
      style: {
        color: "#36acaa"
      }
    },
    {
      types: ["atrule", "keyword", "attr-name", "selector"],
      style: {
        color: "#00a4db"
      }
    },
    {
      types: ["function", "deleted", "tag"],
      style: {
        color: "#d73a49"
      }
    },
    {
      types: ["function-variable"],
      style: {
        color: "#6f42c1"
      }
    },
    {
      types: ["tag", "selector", "keyword"],
      style: {
        color: "#00009f"
      }
    }
  ]
}, Xe = "_markdown_np770_1", e9 = "_codeBlock_np770_1", t9 = "_input_np770_57", n9 = "_success_np770_70", o9 = "_error_np770_75", c9 = "_selectable_np770_80", s9 = "_extraInputInSingleLIne_np770_84", l9 = "_extraSelectList_np770_94", z = {
  markdown: Xe,
  codeBlock: e9,
  input: t9,
  success: n9,
  error: o9,
  selectable: c9,
  extraInputInSingleLIne: s9,
  extraSelectList: l9
};
z1.languages.typein = {
  input: /__\d+__/
};
const F1 = W1({
  value: []
}), I1 = X1(), O = ({
  children: n,
  value: t = [],
  onChange: o,
  mode: s,
  options: r,
  variant: l,
  ...h
}) => {
  const i = Y("change_event_" + Date.now());
  return te(() => {
    const a = (d) => {
      o == null || o(d);
    };
    I1.on(i.current, a);
  }), /* @__PURE__ */ e(
    F1.Provider,
    {
      value: {
        value: t,
        mode: s,
        options: r,
        variant: l,
        changeEventKey: i.current
      },
      children: /* @__PURE__ */ e(
        K1,
        {
          ...h,
          remarkPlugins: [ee, oe],
          rehypePlugins: [ne, ce],
          children: n,
          className: z.markdown,
          components: {
            code: r9,
            a: ({ node: a, children: d, ...v }) => /* @__PURE__ */ e("a", { className: z.link, target: "_blank", ...v, children: d })
          }
        }
      )
    }
  );
}, r9 = ({
  inline: n,
  children: t,
  className: o,
  node: s,
  ...r
}) => {
  const { value: l, changeEventKey: h, mode: i, options: a, variant: d } = G1(F1), v = B(() => t.filter((p) => !!p).length > 0, [t]), m = Y(0), u = Y(null);
  v1(() => {
    var p, C;
    u.current && (i === "drag-and-drop" || i === "single-type-in" || i === "multi-type-in") && ((C = (p = u.current) == null ? void 0 : p.querySelector("input")) == null || C.focus());
  }, [i]);
  const w = (p, C) => {
    const H = l ? [...l] : [];
    H[C] = p.currentTarget.value, h && I1.emit(h, H);
  }, N = (p) => {
    var F;
    const C = l ? [...l] : [];
    C[m.current] = p, h && I1.emit(h, C);
    const H = u.current.querySelectorAll("input");
    (F = H == null ? void 0 : H[m.current + 1]) == null || F.focus();
  }, D = (p) => {
    m.current = p;
  }, E = (p = 0) => {
    var C;
    return !l || !l[p] ? "" : i === "single-type-in" || i === "multi-type-in" ? (l == null ? void 0 : l[p]) || "" : i === "drag-and-drop" && ((C = a == null ? void 0 : a.find((H) => H.text === l[p])) == null ? void 0 : C.text) || "";
  }, V = (p = "") => {
    const C = p.length * 13;
    return C >= 80 ? C : 80;
  }, S = ({
    className: p,
    style: C,
    tokens: H,
    getLineProps: F,
    getTokenProps: X
  }) => /* @__PURE__ */ c("div", { className: f(z.codeBlock, p), style: C, children: [
    /* @__PURE__ */ e("br", {}),
    H.map((u1, b1) => /* @__PURE__ */ e("div", { ...F({ line: u1, key: b1 }), children: u1.map((W, _1) => {
      var m1, b;
      if (/__\d+__/.test(W.content.trim())) {
        const I = Number(
          (m1 = W.content.trim().match(/__(\d+)__/)) == null ? void 0 : m1[1]
        ), [N1, R] = W.content.split(/__\d+__/), x1 = ((b = a == null ? void 0 : a[I]) == null ? void 0 : b.maxLength) || void 0, l1 = E(I);
        return /* @__PURE__ */ c("span", { ...X({ token: W, key: _1 }), children: [
          N1,
          /* @__PURE__ */ e(
            "input",
            {
              className: f(
                z.input,
                i === "drag-and-drop" && z.selectable,
                d && z[d]
              ),
              disabled: !!d,
              "data-key": "input-" + I,
              maxLength: x1,
              style: { width: V(l1) },
              value: l1,
              onChange: (P) => w(P, I),
              onFocus: () => D(I)
            },
            "input-" + I
          ),
          R
        ] });
      }
      return /* @__PURE__ */ e("span", { ...X({ token: W, key: _1 }) });
    }) }))
  ] }), x = () => {
    var p;
    if (i === "single-type-in")
      return t.join(`
`).match(/__\d+__/g) ? null : /* @__PURE__ */ e("div", { className: z.extraInputInSingleLIne, children: /* @__PURE__ */ e(
        "input",
        {
          className: f(z.input, d && z[d]),
          type: "text",
          value: E(),
          onChange: (C) => w(C, 0),
          maxLength: ((p = a == null ? void 0 : a[0]) == null ? void 0 : p.maxLength) || void 0,
          disabled: !!d
        }
      ) });
    if (i === "drag-and-drop") {
      const C = a == null ? void 0 : a.filter((H) => !(l != null && l.includes(H.text)));
      return /* @__PURE__ */ e("div", { className: z.extraSelectList, children: /* @__PURE__ */ e(
        Ke,
        {
          options: C,
          onChange: N
        }
      ) });
    }
    return null;
  }, _ = () => {
    if (v && (o != null && o.includes("typein")))
      return /* @__PURE__ */ e(
        Q1,
        {
          Prism: z1,
          theme: Qe,
          code: t.join(`
`),
          language: "typein",
          children: S
        }
      );
    const p = /language-(\w+)/.exec(o || "");
    if (!n && p) {
      const C = String(t).replace(/\n$/, "");
      return C ? /* @__PURE__ */ e(
        q1,
        {
          children: C,
          style: E1,
          language: p[1],
          PreTag: "div",
          ...r
        }
      ) : null;
    }
    return /* @__PURE__ */ e(q1, { style: E1, children: String(t) });
  };
  return n ? /* @__PURE__ */ e("code", { children: t }) : /* @__PURE__ */ c("div", { ref: u, children: [
    _(),
    x()
  ] });
}, i9 = "_note_1q6zq_1", a9 = "_icon_1q6zq_9", d9 = "_content_1q6zq_14", $1 = {
  note: i9,
  icon: a9,
  content: d9
}, p2 = ({
  content: n,
  children: t,
  className: o,
  hideIcon: s = !1,
  ...r
}) => /* @__PURE__ */ c("div", { className: f($1.note, o), ...r, children: [
  !s && /* @__PURE__ */ e("div", { className: $1.icon, children: /* @__PURE__ */ e("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", children: /* @__PURE__ */ e(
    "path",
    {
      d: "M16 2C8.27 2 2 8.27 2 16C2 23.732 8.27 30 16 30C23.734 30 30 23.732 30 16C30 8.27 23.734 2 16 2ZM16 24C15.174 24 14.5 23.328 14.5 22.5C14.5 21.672 15.174 21 16 21C16.832 21 17.5 21.672 17.5 22.5C17.5 23.328 16.832 24 16 24ZM17.5 16.5C17.5 17.33 16.832 18 16 18C15.174 18 14.5 17.33 14.5 16.5V9.5C14.5 8.67 15.174 8 16 8C16.832 8 17.5 8.67 17.5 9.5V16.5Z",
      fill: "#FF9A00"
    }
  ) }) }),
  /* @__PURE__ */ e(
    O,
    {
      className: $1.content,
      children: n || t
    }
  )
] }), G = {
  "coach-card": "_coach-card_1wtqo_1",
  "coach-header": "_coach-header_1wtqo_6",
  "coach-icon": "_coach-icon_1wtqo_9",
  "coach-content": "_coach-content_1wtqo_19",
  "coach-name": "_coach-name_1wtqo_22",
  "coach-description": "_coach-description_1wtqo_29",
  "coach-footer": "_coach-footer_1wtqo_34",
  "coach-button-finished": "_coach-button-finished_1wtqo_37"
}, h9 = (n) => /* @__PURE__ */ c("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", ...n, children: [
  /* @__PURE__ */ e("g", { clipPath: "url(#clip0_222_275)", children: /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20ZM9.5747 14.6416L16.267 6.64163L14.733 5.35837L8.66377 12.6135L5.61887 10.2145L4.38113 11.7855L8.18882 14.7855L8.95161 15.3865L9.5747 14.6416Z",
      fill: "white"
    }
  ) }),
  /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_222_275", children: /* @__PURE__ */ e(
    "rect",
    {
      width: "20",
      height: "20",
      fill: "white",
      transform: "translate(0.5)"
    }
  ) }) })
] }), u9 = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e("rect", { width: "80", height: "80", rx: "4", fill: "#D26A54" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M40 23.2361L43.3147 33.4377C43.5825 34.2617 44.3504 34.8197 45.2168 34.8197H55.9434L47.2654 41.1246C46.5645 41.6339 46.2711 42.5366 46.5389 43.3607L49.8536 53.5623L41.1756 47.2574C40.4746 46.7481 39.5254 46.7481 38.8244 47.2574L30.1464 53.5623L33.4611 43.3607C33.7289 42.5366 33.4355 41.6339 32.7346 41.1246L32.1468 41.9336L32.7346 41.1246L24.0566 34.8197H34.7832C35.6496 34.8197 36.4175 34.2617 36.6853 33.4377L40 23.2361Z",
          stroke: "white",
          strokeWidth: "2"
        }
      )
    ]
  }
), C2 = ({
  name: n,
  description: t,
  points: o,
  finished: s = !1,
  onButtonClick: r = () => {
  }
}) => /* @__PURE__ */ c("div", { className: G["coach-card"], children: [
  /* @__PURE__ */ c("div", { className: G["coach-header"], children: [
    /* @__PURE__ */ e("div", { className: G["coach-icon"], children: /* @__PURE__ */ e(u9, {}) }),
    /* @__PURE__ */ c("div", { className: G["coach-content"], children: [
      /* @__PURE__ */ e("div", { className: G["coach-name"], children: n }),
      /* @__PURE__ */ e("div", { className: G["coach-description"], children: t })
    ] })
  ] }),
  /* @__PURE__ */ e("div", { className: G["coach-footer"], children: /* @__PURE__ */ c(
    $,
    {
      color: s ? "green" : "blue",
      variant: "filled",
      width: "100%",
      onClick: r,
      children: [
        "练习 (+",
        o,
        "钻石)",
        s && /* @__PURE__ */ e(h9, { style: { marginLeft: 5 } })
      ]
    }
  ) })
] }), _9 = "_container_1eays_1", m9 = "_header_1eays_13", p9 = "_left_1eays_21", C9 = "_close_1eays_25", g9 = "_title_1eays_33", f9 = "_right_1eays_39", v9 = "_content_1eays_51", y9 = "_tab_1eays_66", w9 = "_vipTabTag_1eays_88", b9 = "_cases_1eays_114", N9 = "_running_1eays_134", g = {
  container: _9,
  header: m9,
  left: p9,
  close: C9,
  title: g9,
  right: f9,
  content: v9,
  "left-header": "_left-header_1eays_59",
  tab: y9,
  "tab-active": "_tab-active_1eays_76",
  vipTabTag: w9,
  "left-content": "_left-content_1eays_97",
  "hint-content": "_hint-content_1eays_103",
  "hint-icon": "_hint-icon_1eays_111",
  cases: b9,
  "right-header": "_right-header_1eays_125",
  running: N9,
  "modal-content": "_modal-content_1eays_146",
  "modal-footer": "_modal-footer_1eays_152"
}, x9 = "_container_15m2b_1", k9 = "_header_15m2b_6", L9 = "_icon_15m2b_17", $9 = "_arrow_15m2b_25", M9 = "_content_15m2b_33", V9 = "_title_15m2b_36", H9 = "_actions_15m2b_41", B9 = "_titleButton_15m2b_45", I9 = "_input_15m2b_51", Z9 = "_output_15m2b_52", q9 = "_diffContent_15m2b_72", M = {
  container: x9,
  header: k9,
  "header-left": "_header-left_15m2b_13",
  icon: L9,
  arrow: $9,
  content: M9,
  title: V9,
  actions: H9,
  titleButton: B9,
  input: I9,
  output: Z9,
  "user-output": "_user-output_15m2b_63",
  diffContent: q9
}, D9 = (n) => /* @__PURE__ */ c("svg", { width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", ...n, children: [
  /* @__PURE__ */ e("g", { clipPath: "url(#clip0_316_462)", children: /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM16.3851 25.4428L28.8851 13.4428L26.1149 10.5572L15.0286 21.2001L9.41421 15.5858L6.58579 18.4142L13.5858 25.4142L14.9714 26.7999L16.3851 25.4428Z",
      fill: "#40BF9C"
    }
  ) }),
  /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_316_462", children: /* @__PURE__ */ e("rect", { width: "36", height: "36", fill: "white" }) }) })
] }), S9 = (n) => /* @__PURE__ */ e("svg", { width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", ...n, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M17.8088 0.911133C8.42629 0.911133 0.821289 8.51613 0.821289 17.8986C0.821289 27.2811 8.42629 34.8861 17.8088 34.8861C27.1913 34.8861 34.7963 27.2811 34.7963 17.8986C34.785 8.51613 27.18 0.911133 17.8088 0.911133ZM26.2125 24.2436L23.355 27.1011L17.8088 21.5549L12.2625 27.1011L9.40504 24.2436L14.9513 18.6974L9.40504 13.1511L12.2625 10.2936L17.8088 15.8399L23.355 10.2936L26.2125 13.1511L20.6663 18.6974L26.2125 24.2436Z",
    fill: "#F26A58"
  }
) }), A1 = (n) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...n, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M15.0711 4.99998L11.5355 8.53551L8 12.071L15.0711 19.1421",
    stroke: "#6B7F99",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
) }), h1 = (n) => /* @__PURE__ */ c("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", ...n, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M1 1L11 11",
      stroke: "#2D3846",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M11 1L1 11",
      stroke: "#2D3846",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    }
  )
] }), T9 = "_dialog_uk1y9_1", E9 = "_backdrop_uk1y9_14", R9 = "_content_uk1y9_21", z9 = "_draggable_uk1y9_31", F9 = "_header_uk1y9_55", A9 = "_close_uk1y9_62", P9 = "_body_uk1y9_73", J = {
  dialog: T9,
  backdrop: E9,
  content: R9,
  draggable: z9,
  header: F9,
  close: A9,
  body: P9
}, c1 = ({
  title: n = "",
  visible: t,
  children: o,
  className: s = "",
  contentClassName: r = "",
  mainClassName: l,
  draggable: h = !1,
  backdrop: i = !0,
  portal: a = !0,
  onClose: d = () => {
  }
}) => {
  const v = () => {
    d();
  }, m = () => /* @__PURE__ */ c("div", { className: f("quark-modal-container", J.dialog, s), children: [
    !h && i && /* @__PURE__ */ e("div", { className: J.backdrop }),
    /* @__PURE__ */ e(se, { handle: ".drag-handle", children: /* @__PURE__ */ c("div", { className: f(J.content, l), children: [
      h && /* @__PURE__ */ e("div", { className: f(J.draggable, "drag-handle") }),
      /* @__PURE__ */ c("div", { className: J.header, children: [
        n,
        /* @__PURE__ */ e("div", { className: f("close", J.close), onClick: v, children: /* @__PURE__ */ e(h1, { style: { width: 24 } }) })
      ] }),
      /* @__PURE__ */ e("div", { className: f(J.body, r), children: o })
    ] }) })
  ] });
  return a ? Y1(/* @__PURE__ */ e(T, { children: t && m() }), document.body) : /* @__PURE__ */ e(T, { children: t && m() });
}, j9 = D1.default || D1, O9 = ({
  index: n,
  dataSource: t,
  expand: o = !1,
  onHelpClick: s
}) => {
  const { succeeded: r, input: l, expected_output: h, actual_output: i } = t, [a, d] = y(o), [v, m] = y(!1), u = () => {
    d(!a);
  }, w = (N) => N.replace(/\n/g, "⏎").replace(/\s/g, "⌷");
  return /* @__PURE__ */ c("div", { className: M.container, children: [
    /* @__PURE__ */ c("div", { className: M.header, onClick: u, children: [
      /* @__PURE__ */ c("div", { className: M["header-left"], children: [
        /* @__PURE__ */ e("div", { className: M.icon, children: r ? /* @__PURE__ */ e(D9, {}) : /* @__PURE__ */ e(S9, {}) }),
        /* @__PURE__ */ c("div", { className: M.title, children: [
          "测试用例",
          n + 1
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: M.arrow, children: /* @__PURE__ */ e(
        A1,
        {
          style: {
            transform: `rotate(${a ? 90 : 270}deg)`
          }
        }
      ) })
    ] }),
    a && /* @__PURE__ */ c("div", { className: M.content, children: [
      /* @__PURE__ */ e("div", { className: M.title, children: "输入内容" }),
      /* @__PURE__ */ e("div", { className: M.input, children: l.trim() }),
      /* @__PURE__ */ c("div", { className: M.title, children: [
        "你的输出",
        /* @__PURE__ */ c("div", { className: M.actions, children: [
          !r && /* @__PURE__ */ e(
            $,
            {
              color: "red",
              className: M.titleButton,
              onClick: () => s(),
              children: "AI答疑"
            }
          ),
          !r && /* @__PURE__ */ e(
            $,
            {
              color: "red",
              className: M.titleButton,
              onClick: () => m(!0),
              children: "查看差异"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ e("div", { className: M["user-output"], children: i }),
      /* @__PURE__ */ e("div", { className: M.title, children: "预期输出" }),
      /* @__PURE__ */ e("div", { className: M.output, children: /* @__PURE__ */ e(O, { children: `\`\`\`text
${h}
\`\`\`` }) })
    ] }),
    /* @__PURE__ */ e(
      c1,
      {
        title: "差异对比(⏎为换行，⌷为空格)",
        visible: v,
        onClose: () => m(!1),
        children: /* @__PURE__ */ e("div", { className: M.diffContent, children: /* @__PURE__ */ e(
          j9,
          {
            leftTitle: "你的输出",
            oldValue: w(i),
            rightTitle: "预期输出",
            newValue: w(h),
            splitView: !0
          }
        ) })
      }
    )
  ] });
}, W9 = "_container_d5qy1_1", G9 = "_backdrop_d5qy1_1", J9 = "_content_d5qy1_9", U9 = "_slidein_d5qy1_1", Y9 = "_header_d5qy1_20", K9 = "_close_d5qy1_28", Q9 = "_body_d5qy1_38", X9 = "_slideout_d5qy1_1", et = "_backdropout_d5qy1_1", j = {
  container: W9,
  backdrop: G9,
  content: J9,
  slidein: U9,
  header: Y9,
  close: K9,
  body: Q9,
  "content-fade-out": "_content-fade-out_d5qy1_41",
  slideout: X9,
  "backdrop-fade-out": "_backdrop-fade-out_d5qy1_44",
  backdropout: et
}, tt = ({ visible: n = !1, onClose: t, children: o }) => {
  const [s, r] = y(!1), l = () => {
    r(!0), setTimeout(() => {
      t(), r(!1);
    }, 400);
  };
  return /* @__PURE__ */ e(T, { children: n && /* @__PURE__ */ c("div", { className: j.container, children: [
    /* @__PURE__ */ e(
      "div",
      {
        className: f(j.backdrop, {
          [j["backdrop-fade-out"]]: s
        }),
        onClick: l
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        className: f(j.content, {
          [j["content-fade-out"]]: s
        }),
        children: [
          /* @__PURE__ */ c("div", { className: j.header, children: [
            /* @__PURE__ */ c("div", { className: j.close, onClick: l, children: [
              "隐藏",
              /* @__PURE__ */ e(A1, {})
            ] }),
            /* @__PURE__ */ e("div", { children: "答案" })
          ] }),
          /* @__PURE__ */ e("div", { className: j.body, children: o })
        ]
      }
    )
  ] }) });
}, nt = {
  "language-tag": "_language-tag_cc5c1_1"
}, ot = (n) => {
  const t = n.toLowerCase();
  return t === "javascript" ? "JS" : t.includes("python") ? "PY" : t.includes("go") ? "GO" : t.toUpperCase();
}, K = ({
  language: n = "",
  className: t,
  ...o
}) => /* @__PURE__ */ e("div", { className: f(nt["language-tag"], t), ...o, children: ot(n) }), ct = "_loading_1r062_1", st = "_image_1r062_8", lt = "_fullscreen_1r062_14", rt = "_backdrop_1r062_25", f1 = {
  loading: ct,
  image: st,
  fullscreen: lt,
  backdrop: rt
}, it = "//python2fun.oss-cn-beijing.aliyuncs.com/%40quark-app/learn/static/loading.gif", at = "//python2fun.oss-cn-beijing.aliyuncs.com/%40quark-app/learn/static/code-running.gif", y1 = ({
  visible: n = !0,
  type: t = "default",
  fullscreen: o = !1,
  ...s
}) => {
  const r = B(() => t === "code" ? at : it, [t]), l = B(() => t === "code" ? 40 : 100, [t]);
  return /* @__PURE__ */ e(T, { children: n && /* @__PURE__ */ c(
    "div",
    {
      className: o ? f1.fullscreen : f1.loading,
      ...s,
      children: [
        o && /* @__PURE__ */ e("div", { className: f1.backdrop }),
        /* @__PURE__ */ e("img", { className: f1.image, src: r, alt: "loading", width: l })
      ]
    }
  ) });
}, s1 = (n) => {
  const t = n.toLowerCase();
  return t.includes("python") ? "python" : t.includes("go") ? "go" : t === "c++" ? "cpp" : t === "nodejs" || t === "js" ? "javascript" : t;
}, Z1 = (n) => /* @__PURE__ */ e("svg", { width: "11", height: "14", viewBox: "0 0 11 14", fill: "none", ...n, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M10.5 6.13397C11.1667 6.51888 11.1667 7.48112 10.5 7.86602L1.5 13.0622C0.833332 13.4471 3.43203e-07 12.966 3.76852e-07 12.1962L8.31114e-07 1.80385C8.64763e-07 1.03405 0.833334 0.552922 1.5 0.937822L10.5 6.13397Z",
    fill: "white"
  }
) }), dt = (n) => /* @__PURE__ */ e(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    ...n,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M14 0C6.27 0 0 6.27 0 14C0 21.732 6.27 28 14 28C21.734 28 28 21.732 28 14C28 6.27 21.734 0 14 0ZM14 22C13.174 22 12.5 21.328 12.5 20.5C12.5 19.672 13.174 19 14 19C14.832 19 15.5 19.672 15.5 20.5C15.5 21.328 14.832 22 14 22ZM15.5 14.5C15.5 15.33 14.832 16 14 16C13.174 16 12.5 15.33 12.5 14.5V7.5C12.5 6.67 13.174 6 14 6C14.832 6 15.5 6.67 15.5 7.5V14.5Z",
        fill: "#FF9A00"
      }
    )
  }
), ht = "_title_q8rhg_10", M1 = {
  "success-footer": "_success-footer_q8rhg_1",
  title: ht,
  "sub-title": "_sub-title_q8rhg_15"
}, ut = ({
  onButtonClick: n = () => {
  }
}) => /* @__PURE__ */ c("div", { className: M1["success-footer"], children: [
  /* @__PURE__ */ e("div", { className: M1.title, children: "实践出真知!" }),
  /* @__PURE__ */ e("div", { className: M1["sub-title"], children: "完成挑战" }),
  /* @__PURE__ */ e($, { variant: "outlined", color: "green", onClick: () => n(), children: "继续" })
] }), Q = 16, _t = Q * 1.5, mt = "_loading_xc4y9_1", pt = "_rotation_xc4y9_1", Ct = {
  loading: mt,
  rotation: pt
}, w1 = () => /* @__PURE__ */ c(
  "svg",
  {
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    className: Ct.loading,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M742.29455 334.277347l-52.575897-52.575897c-10.06998-10.06998-10.06998-26.401948 0-36.471929l100.717803-100.717803c10.06998-10.06998 26.401948-10.06998 36.471929 0l52.575897 52.575897c10.06998 10.06998 10.06998 26.401948 0 36.471929l-100.717803 100.717803c-10.07398 10.07398-26.401948 10.07398-36.471929 0z",
          fill: "#CEE8FA",
          "p-id": "4093"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M760.528515 371.305275c-14.759971 0-28.635944-5.747989-39.075924-16.183969l-52.575897-52.575897c-10.43598-10.43598-16.185968-24.315953-16.185969-39.075924 0-14.761971 5.749989-28.641944 16.189969-39.081923l100.713803-100.713804c10.43998-10.43598 24.315953-16.183968 39.077924-16.183968 14.759971 0 28.635944 5.747989 39.075923 16.179968l52.575898 52.579898c10.43598 10.43398 16.185968 24.311953 16.185968 39.075923 0 14.759971-5.749989 28.637944-16.189968 39.077924l-100.713804 100.713803c-10.43598 10.43998-24.313953 16.187968-39.077923 16.187969z m-47.365908-107.83779l47.365908 47.367908 95.505813-95.509814-47.361907-47.367907-95.509814 95.509813z",
          fill: "#2D527C",
          "p-id": "4094"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M197.087615 879.484282l-52.575897-52.575897c-10.06998-10.06998-10.06998-26.401948 0-36.471929l100.717803-100.717803c10.06998-10.06998 26.401948-10.06998 36.471929 0l52.575897 52.575897c10.06998 10.06998 10.06998 26.401948 0 36.471929l-100.717803 100.717803c-10.06998 10.06998-26.397948 10.06998-36.471929 0z",
          fill: "#CEE8FA",
          "p-id": "4095"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M215.325579 916.51021c-14.759971 0-28.635944-5.747989-39.075923-16.183968l-52.575898-52.579898c-10.43598-10.43398-16.185968-24.311953-16.185968-39.075923 0-14.759971 5.749989-28.637944 16.189968-39.077924l100.713804-100.713803c10.43598-10.43598 24.315953-16.185968 39.077923-16.185969 14.759971 0 28.635944 5.747989 39.075924 16.183969l52.575897 52.575897c10.43598 10.43598 16.185968 24.315953 16.185969 39.077924 0 14.759971-5.749989 28.637944-16.189969 39.077923l-100.713803 100.713804c-10.44198 10.43798-24.317953 16.187968-39.077924 16.187968z m-47.365907-107.839789l47.361907 47.367907 95.509814-95.509813-47.365908-47.367908-95.505813 95.509814z",
          fill: "#2D527C",
          "p-id": "4096"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M689.716653 742.29455l52.575897-52.575897c10.06998-10.06998 26.401948-10.06998 36.471929 0l100.717803 100.717803c10.06998 10.06998 10.06998 26.401948 0 36.471929l-52.575897 52.575897c-10.06998 10.06998-26.401948 10.06998-36.471929 0l-100.717803-100.717803c-10.06998-10.07398-10.06998-26.401948 0-36.471929z",
          fill: "#CEE8FA",
          "p-id": "4097"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M808.672421 916.51021c-14.763971 0-28.637944-5.749989-39.077924-16.185968l-100.717803-100.717804c-10.43598-10.43998-16.185968-24.315953-16.185969-39.077923s5.749989-28.641944 16.189969-39.081924l52.569897-52.569897c10.44198-10.43998 24.317953-16.185968 39.077924-16.185969 14.763971 0 28.641944 5.749989 39.077923 16.185969l100.717804 100.713803c10.43598 10.43998 16.185968 24.315953 16.185968 39.077924s-5.749989 28.641944-16.189968 39.081923l-52.569898 52.569898c-10.44198 10.44398-24.317953 16.189968-39.077923 16.189968z m-95.509814-155.981695l95.509814 95.509813 47.361907-47.367907-95.505813-95.509814-47.365908 47.367908z",
          fill: "#2D527C",
          "p-id": "4098"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M144.513718 197.087615l52.575897-52.575897c10.06998-10.06998 26.401948-10.06998 36.471929 0l100.717803 100.717803c10.06998 10.06998 10.06998 26.401948 0 36.471929l-52.575897 52.575897c-10.06998 10.06998-26.401948 10.06998-36.471929 0l-100.717803-100.713803c-10.06998-10.07398-10.06998-26.401948 0-36.475929z",
          fill: "#CEE8FA",
          "p-id": "4099"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M263.469485 371.305275c-14.761971 0-28.641944-5.749989-39.077923-16.185969l-100.717804-100.713803c-10.43598-10.43998-16.185968-24.315953-16.185968-39.077924 0-14.761971 5.749989-28.641944 16.189968-39.081923l52.569898-52.569898c10.44198-10.43998 24.317953-16.185968 39.077923-16.185968 14.761971 0 28.637944 5.747989 39.077924 16.183968l100.717803 100.717804c10.43598 10.43998 16.185968 24.315953 16.185969 39.077923 0 14.759971-5.749989 28.637944-16.189969 39.077924l-52.569897 52.569897c-10.44598 10.43998-24.321952 16.187968-39.077924 16.187969z m-95.509813-155.979696l95.505813 95.509814 47.365908-47.365908-95.505814-95.511813-47.365907 47.367907zM894.768252 604.436819h-68.467866c-30.47194 0-55.263892-24.791952-55.263892-55.261892v-74.353854c0-30.47194 24.791952-55.261892 55.263892-55.261892h142.433722c30.47194 0 55.263892 24.791952 55.263892 55.261892v74.353854c0 16.277968-13.197974 29.471942-29.471942 29.471943s-29.471942-13.195974-29.471943-29.471943v-70.669862h-135.071736v66.98787h64.787873c16.273968 0 29.471942 13.195974 29.471943 29.471942 0 16.279968-13.197974 29.471942-29.473943 29.471942zM197.697614 604.436819H55.263892C24.791952 604.436819 0 579.644868 0 549.176927v-74.353854c0-16.277968 13.197974-29.471942 29.471942-29.471943s29.471942 13.195974 29.471943 29.471943v70.669862h135.071736v-66.98787H128.533749c-16.273968 0-29.471942-13.195974-29.471942-29.471942 0-16.277968 13.197974-29.471942 29.471942-29.471942h69.163865c30.47194 0 55.263892 24.791952 55.263892 55.261892v74.353854c0 30.46794-24.791952 55.259892-55.263892 55.259892zM549.176927 1023.998H474.819073c-16.273968 0-29.471942-13.193974-29.471943-29.471942s13.197974-29.471942 29.471943-29.471943h70.673862v-135.071736h-66.98787v66.177871c0 16.277968-13.197974 29.471942-29.471942 29.471942s-29.471942-13.193974-29.471942-29.471942V826.298386c0-30.47194 24.789952-55.261892 55.261892-55.261892h74.357854c30.47194 0 55.261892 24.791952 55.261892 55.261892v142.435722C604.436819 999.206048 579.648868 1023.998 549.176927 1023.998zM549.176927 252.961506H474.819073c-30.47194 0-55.261892-24.791952-55.261892-55.261892V55.259892C419.557181 24.789952 444.347132 0 474.819073 0h74.357854c16.273968 0 29.471942 13.195974 29.471943 29.471942s-13.197974 29.471942-29.471943 29.471943h-70.673862v135.071736h66.98787V129.589747c0-16.277968 13.197974-29.471942 29.471942-29.471943s29.471942 13.195974 29.471942 29.471943v68.107867c0.002 30.47194-24.785952 55.263892-55.257892 55.263892zM392.091234 541.470942h-37.235927c-16.273968 0-29.471942-13.195974-29.471943-29.471942 0-16.277968 13.197974-29.471942 29.471943-29.471942h37.235927c16.273968 0 29.471942 13.195974 29.471943 29.471942 0.002 16.277968-13.193974 29.471942-29.471943 29.471942zM530.616964 541.470942H493.379036c-16.273968 0-29.471942-13.195974-29.471942-29.471942 0-16.277968 13.197974-29.471942 29.471942-29.471942h37.237928c16.273968 0 29.471942 13.195974 29.471942 29.471942 0 16.277968-13.193974 29.471942-29.471942 29.471942zM669.138693 541.470942h-37.235927c-16.273968 0-29.471942-13.195974-29.471943-29.471942 0-16.277968 13.197974-29.471942 29.471943-29.471942h37.235927c16.273968 0 29.471942 13.195974 29.471943 29.471942 0.002 16.277968-13.193974 29.471942-29.471943 29.471942z",
          fill: "#2D527C",
          "p-id": "4100"
        }
      )
    ]
  }
), gt = "_difficulty_1lnoa_1", ft = {
  difficulty: gt
}, vt = ({
  difficulty: n
}) => /* @__PURE__ */ e("div", { className: ft.difficulty, children: n }), g2 = ({
  visible: n,
  dataSource: t,
  dataResult: o = null,
  hideAnswer: s = !1,
  running: r = !1,
  logContent: l,
  answerContent: h,
  extraActions: i,
  onRun: a = () => {
  },
  onClose: d = () => {
  },
  onTestCaseHelpClick: v
}) => {
  const m = Y(null), u = B(() => t.code_templates[0], [t.code_templates]), w = B(() => {
    var b;
    return ((b = t.user_data) == null ? void 0 : b.source_code) || u.template;
  }, [t.user_data, u.template]), N = B(() => {
    const I = (t.testcases || []).filter((R) => R.sample).slice(0, 2), N1 = I.length > 1;
    return I.map((R, x1) => {
      const l1 = N1 ? `-${x1 + 1}` : "";
      let P = "";
      return R.stdin.trim() && (P += `
### 示例输入` + l1 + "\n```text", P += `
` + R.stdin + "\n```"), R.expected_output.trim() && (P += `
### 示例输出` + l1 + " \n```text", P += `
` + R.expected_output + "\n```"), R.explanation.trim() && (P += `
> **解释**:
 ${R.explanation}
`), { id: R.id, md: P };
    });
  }, [t]), [D, E] = y(w), [V, S] = y("problem"), [x, _] = y(!1), [p, C] = y(!1), [H, F] = y(!1), X = B(() => !!(o != null && o.is_pass), [o]), u1 = B(() => ((o == null ? void 0 : o.test_results) || []).findIndex((b) => !b.succeeded), [o]), b1 = B(() => D !== u.template, [D, u]), W = () => {
    var b;
    (b = m == null ? void 0 : m.current) == null || b.setValue(u.template), F(!1);
  }, _1 = () => {
    r || a(D, u.language);
  }, m1 = () => {
    if (X) {
      d();
      return;
    }
    C(!0);
  };
  return v1(() => {
    o && S("result");
  }, [o]), /* @__PURE__ */ e(T, { children: n && /* @__PURE__ */ c("div", { className: g.container, children: [
    /* @__PURE__ */ c("div", { className: g.header, children: [
      /* @__PURE__ */ c("div", { className: g.left, children: [
        /* @__PURE__ */ e("div", { className: g.close, onClick: m1, children: /* @__PURE__ */ e(h1, { style: { width: 24 } }) }),
        /* @__PURE__ */ c("div", { className: g.title, children: [
          t.title,
          /* @__PURE__ */ e(vt, { difficulty: t.difficulty })
        ] })
      ] }),
      /* @__PURE__ */ c("div", { className: g.right, children: [
        i,
        b1 && /* @__PURE__ */ e($, { onClick: () => F(!0), children: "重置代码" }),
        !s && /* @__PURE__ */ e($, { onClick: () => _(!0), children: "查看答案" }),
        /* @__PURE__ */ c($, { variant: "filled", onClick: _1, children: [
          "运行代码  ",
          r ? /* @__PURE__ */ e(w1, {}) : /* @__PURE__ */ e(Z1, {})
        ] })
      ] })
    ] }),
    /* @__PURE__ */ c("div", { className: g.content, children: [
      /* @__PURE__ */ c("div", { className: g.left, children: [
        /* @__PURE__ */ c("div", { className: g["left-header"], children: [
          /* @__PURE__ */ e(
            "div",
            {
              className: f({
                [g.tab]: !0,
                [g["tab-active"]]: V === "problem"
              }),
              style: { marginRight: 15 },
              onClick: () => S("problem"),
              children: "题目描述"
            }
          ),
          !!h && /* @__PURE__ */ c(
            "div",
            {
              className: f({
                [g.tab]: !0,
                [g["tab-active"]]: V === "answer"
              }),
              style: { marginRight: 15 },
              onClick: () => S("answer"),
              children: [
                "官方解答",
                /* @__PURE__ */ e("div", { className: g.vipTabTag, children: "pro" })
              ]
            }
          ),
          !!o && /* @__PURE__ */ e(
            "div",
            {
              className: f({
                [g.tab]: !0,
                [g["tab-active"]]: V === "result"
              }),
              style: { marginRight: 15 },
              onClick: () => S("result"),
              children: "测试结果"
            }
          ),
          /* @__PURE__ */ e(
            "div",
            {
              className: f({
                [g.tab]: !0,
                [g["tab-active"]]: V === "log"
              }),
              style: { marginRight: 15 },
              onClick: () => S("log"),
              children: "提交记录"
            }
          )
        ] }),
        /* @__PURE__ */ c("div", { className: g["left-content"], children: [
          V === "problem" && /* @__PURE__ */ c(T, { children: [
            /* @__PURE__ */ e(O, { children: t.problem_statement_md }),
            !!t.input_format_md.trim() && /* @__PURE__ */ e(O, { children: `
### 输入格式
${t.input_format_md}` }),
            !!t.constraints_md.trim() && /* @__PURE__ */ e(O, { children: `
### 限制条件
${t.constraints_md}` }),
            !!t.output_format_md.trim() && /* @__PURE__ */ e(O, { children: `
### 输出格式
${t.output_format_md}` }),
            N.map((b) => /* @__PURE__ */ e(O, { children: b.md }, b.id)),
            !!t.hint_md.trim() && /* @__PURE__ */ c("div", { className: g["hint-content"], children: [
              /* @__PURE__ */ e("div", { className: g["hint-icon"], children: /* @__PURE__ */ e(dt, {}) }),
              /* @__PURE__ */ e(O, { children: t.hint_md })
            ] })
          ] }),
          V === "result" && !!o && /* @__PURE__ */ e("div", { className: g.cases, children: o.test_results.map((b, I) => /* @__PURE__ */ e(
            O9,
            {
              index: I,
              dataSource: b,
              expand: I === u1,
              onHelpClick: () => v(I)
            },
            I
          )) }),
          V === "log" && l,
          V === "answer" && h
        ] })
      ] }),
      /* @__PURE__ */ c("div", { className: g.right, children: [
        /* @__PURE__ */ e("div", { className: g["right-header"], children: /* @__PURE__ */ e(K, { language: u.language }) }),
        /* @__PURE__ */ e(
          o1,
          {
            theme: "vs-dark",
            defaultLanguage: s1(u.language),
            defaultValue: D,
            height: X ? "calc(100% - 48px - 180px)" : "calc(100% - 48px)",
            className: g.editor,
            options: {
              fontSize: Q,
              minimap: {
                enabled: !1
              },
              scrollBeyondLastLine: !1
            },
            onChange: (b) => E(b),
            onMount: (b) => m.current = b
          }
        ),
        r && /* @__PURE__ */ e("div", { className: g.running, children: /* @__PURE__ */ e(y1, { type: "code" }) }),
        X && /* @__PURE__ */ e(ut, { onButtonClick: () => d("success") })
      ] })
    ] }),
    /* @__PURE__ */ e(
      tt,
      {
        visible: x,
        onClose: () => {
          _(!1);
        },
        children: /* @__PURE__ */ e(
          o1,
          {
            theme: "vs-dark",
            defaultLanguage: s1(u.language),
            defaultValue: u.solution_code,
            height: "calc(100vh - 90px)",
            className: g.editor,
            options: {
              readOnly: !0,
              fontSize: Q,
              minimap: {
                enabled: !1
              },
              scrollBeyondLastLine: !1
            },
            onChange: (b) => E(b)
          }
        )
      }
    ),
    /* @__PURE__ */ c(
      c1,
      {
        title: "你确认要退出吗?",
        visible: p,
        onClose: () => C(!1),
        children: [
          /* @__PURE__ */ e("div", { className: g["modal-content"], children: "退出后，你输入的数据将不会被保存" }),
          /* @__PURE__ */ c("div", { className: g["modal-footer"], children: [
            /* @__PURE__ */ e(
              $,
              {
                onClick: () => {
                  C(!1), d();
                },
                children: "退出"
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                variant: "filled",
                onClick: () => C(!1),
                children: "继续解决问题"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ c(
      c1,
      {
        title: "重置代码",
        visible: H,
        onClose: () => F(!1),
        children: [
          /* @__PURE__ */ e("div", { className: g["modal-content"], children: "重置后，你输入的代码将被清空" }),
          /* @__PURE__ */ c("div", { className: g["modal-footer"], children: [
            /* @__PURE__ */ e($, { onClick: () => F(!1), children: "取消" }),
            /* @__PURE__ */ e($, { variant: "filled", onClick: () => W(), children: "确定" })
          ] })
        ]
      }
    )
  ] }) });
}, yt = "_content_1uyww_9", wt = "_actions_1uyww_20", bt = "_actionItem_1uyww_27", Nt = "_aiTrigger_1uyww_30", U = {
  "code-wrapper": "_code-wrapper_1uyww_1",
  content: yt,
  "content-mark": "_content-mark_1uyww_13",
  actions: wt,
  actionItem: bt,
  aiTrigger: Nt
}, xt = "_copyTag_1klhh_1", kt = {
  copyTag: xt
}, Lt = ({ source: n, className: t }) => {
  const o = () => {
    le(n), A.success("复制成功", { duration: 1e3 });
  };
  return /* @__PURE__ */ e("div", { className: f(kt.copyTag, t), onClick: o, children: "复制" });
}, f2 = ({
  code: n,
  language: t,
  runnable: o = !0,
  onButtonClick: s = () => {
  },
  onAIClick: r
}) => {
  const l = Y(null);
  function h(i) {
    l.current = i;
    const a = i._modelData.model.getLineCount();
    i._domElement.style.height = a * _t + "px";
  }
  return /* @__PURE__ */ c("div", { className: U["code-wrapper"], children: [
    /* @__PURE__ */ e("div", { className: U.content, children: /* @__PURE__ */ e(
      o1,
      {
        theme: "vs-dark",
        defaultLanguage: s1(t),
        defaultValue: n,
        onMount: h,
        options: {
          readOnly: !0,
          fontSize: Q,
          minimap: {
            enabled: !1
          },
          scrollBeyondLastLine: !1,
          lineNumbers: "off",
          folding: !1,
          lineDecorationsWidth: 0,
          // 关闭当前行高亮
          renderLineHighlight: "none",
          // 关闭滚动条中的border
          overviewRulerBorder: !1
        }
      }
    ) }),
    /* @__PURE__ */ c("div", { className: U.actions, children: [
      /* @__PURE__ */ e(Lt, { className: U.actionItem, source: n }),
      r && /* @__PURE__ */ e(
        K,
        {
          language: "AI答疑",
          className: f(U.actionItem, U.aiTrigger),
          onClick: r
        }
      ),
      /* @__PURE__ */ e(K, { language: t, className: U.actionItem })
    ] }),
    o && /* @__PURE__ */ e($, { variant: "filled", width: "100%", onClick: s, children: "尝试一下" })
  ] });
}, $t = "_container_14oau_1", Mt = "_header_14oau_13", Vt = "_left_14oau_22", Ht = "_close_14oau_26", Bt = "_title_14oau_34", It = "_right_14oau_37", Zt = "_content_14oau_49", qt = "_chatGpt_14oau_71", Dt = "_running_14oau_88", St = "_output_14oau_102", Tt = "_files_14oau_118", Et = "_handler_14oau_132", k = {
  container: $t,
  header: Mt,
  left: Vt,
  close: Ht,
  title: Bt,
  right: It,
  content: Zt,
  "left-header": "_left-header_14oau_59",
  "right-header": "_right-header_14oau_60",
  chatGpt: qt,
  running: Dt,
  output: St,
  "output-normal": "_output-normal_14oau_112",
  "output-error": "_output-error_14oau_115",
  files: Tt,
  "stdin-input": "_stdin-input_14oau_124",
  handler: Et
}, Rt = "_file_192tk_1", zt = "_download_192tk_4", R1 = {
  file: Rt,
  download: zt
}, P1 = ({ dataSource: n }) => {
  const { name: t, url: o } = n, s = B(() => {
    const r = t.split(".").slice(-1)[0].toLowerCase();
    return ["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(r);
  }, [t]);
  return /* @__PURE__ */ e("div", { className: R1.file, children: s ? /* @__PURE__ */ e("img", { src: o, alt: "" }) : /* @__PURE__ */ e(
    "a",
    {
      href: o,
      target: "_blank",
      rel: "noreferrer",
      className: R1.download,
      children: t
    }
  ) });
}, Ft = "_stdout_1sti6_1", At = {
  stdout: Ft
}, Pt = ({ format: n, stdout: t }) => {
  if (n === "sql_json") {
    const o = JSON.parse(t);
    return /* @__PURE__ */ e("div", { className: At.stdout, children: o.map(({ headers: s, rows: r }) => /* @__PURE__ */ c("table", { children: [
      /* @__PURE__ */ e("thead", { children: /* @__PURE__ */ e("tr", { children: s.map((l) => /* @__PURE__ */ e("th", { children: l }, l)) }) }),
      /* @__PURE__ */ e("tbody", { children: r.map((l) => /* @__PURE__ */ e("tr", { children: l.map((h) => /* @__PURE__ */ e("td", { children: h.value }, Math.random())) }, Math.random())) })
    ] }, Math.random())) });
  }
  return /* @__PURE__ */ e(T, { children: t });
}, v2 = ({
  visible: n = !1,
  dataSource: t,
  dataResult: o = null,
  running: s = !1,
  checkSdtinFn: r,
  onRun: l = () => {
  },
  onClose: h = () => {
  },
  onChatGPT: i
}) => {
  var x;
  const [a, d] = y(""), [v, m] = y(!1), [u, w] = y(t.content), [N, D] = y(!1), E = () => {
    if (s || N)
      return;
    const _ = t.language;
    D(!0), r(_, u || "").then((p) => {
      p ? m(!0) : (l(a, u, _), m(!1));
    }).finally(() => {
      D(!1);
    });
  }, V = () => {
    a.trim() && (l(a, u, t.language), m(!1));
  }, S = () => {
    h();
  };
  return /* @__PURE__ */ e(T, { children: n && /* @__PURE__ */ c("div", { className: k.container, children: [
    /* @__PURE__ */ c("div", { className: k.header, children: [
      /* @__PURE__ */ c("div", { className: k.left, children: [
        /* @__PURE__ */ e("div", { className: k.close, onClick: S, children: /* @__PURE__ */ e(h1, { style: { width: 24 } }) }),
        /* @__PURE__ */ e("div", { className: k.title, children: t.title })
      ] }),
      /* @__PURE__ */ e("div", { className: k.right, children: /* @__PURE__ */ c($, { variant: "filled", onClick: E, children: [
        "运行  ",
        s || N ? /* @__PURE__ */ e(w1, {}) : /* @__PURE__ */ e(Z1, {})
      ] }) })
    ] }),
    /* @__PURE__ */ c("div", { className: k.content, children: [
      /* @__PURE__ */ c("div", { className: k.left, children: [
        /* @__PURE__ */ e("div", { className: k["left-header"], children: /* @__PURE__ */ e(K, { language: t.language }) }),
        /* @__PURE__ */ e(
          o1,
          {
            theme: "vs-dark",
            defaultLanguage: s1(t.language),
            defaultValue: u,
            height: "calc(100% - 48px)",
            className: k.editor,
            options: {
              fontSize: Q,
              minimap: {
                enabled: !1
              },
              scrollBeyondLastLine: !1
            },
            onChange: (_) => w(_)
          }
        ),
        s && /* @__PURE__ */ e("div", { className: k.running, children: /* @__PURE__ */ e(y1, { type: "code" }) })
      ] }),
      /* @__PURE__ */ c("div", { className: k.right, children: [
        /* @__PURE__ */ e("div", { className: k["right-header"], children: o && i && /* @__PURE__ */ e(
          K,
          {
            language: "AI答疑",
            className: k.chatGpt,
            onClick: i
          }
        ) }),
        /* @__PURE__ */ e("div", { className: k.output, children: !!o && /* @__PURE__ */ c(T, { children: [
          !!o.stderr && /* @__PURE__ */ e("div", { className: k["output-error"], children: o.stderr }),
          !!o.stdout && /* @__PURE__ */ e("div", { className: k["output-normal"], children: /* @__PURE__ */ e(
            Pt,
            {
              format: o.format,
              stdout: o.stdout
            }
          ) }),
          /* @__PURE__ */ e("div", { className: k.files, children: (x = o == null ? void 0 : o.files) == null ? void 0 : x.map((_) => /* @__PURE__ */ e(P1, { dataSource: _ }, _.name)) })
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ c(
      c1,
      {
        visible: v,
        title: "看起来你需要参数输入",
        onClose: () => m(!1),
        children: [
          /* @__PURE__ */ e(
            "textarea",
            {
              className: k["stdin-input"],
              placeholder: "请输入, 换行可输入多个参数",
              onChange: (_) => d(_.target.value)
            }
          ),
          /* @__PURE__ */ e("div", { className: k.handler, children: /* @__PURE__ */ e($, { variant: "filled", onClick: V, children: "尝试一下" }) })
        ]
      }
    )
  ] }) });
}, jt = "_container_pp4vg_1", Ot = "_header_pp4vg_13", Wt = "_left_pp4vg_22", Gt = "_close_pp4vg_26", Jt = "_title_pp4vg_34", Ut = "_right_pp4vg_37", Yt = "_content_pp4vg_49", Kt = "_code_pp4vg_53", Qt = "_output_pp4vg_54", Xt = "_chatGpt_pp4vg_71", en = "_running_pp4vg_88", tn = "_handler_pp4vg_107", Z = {
  container: jt,
  header: Ot,
  left: Wt,
  close: Gt,
  title: Jt,
  right: Ut,
  content: Yt,
  code: Kt,
  output: Qt,
  "code-header": "_code-header_pp4vg_59",
  "output-header": "_output-header_pp4vg_60",
  chatGpt: Xt,
  running: en,
  "stdin-input": "_stdin-input_pp4vg_99",
  handler: tn
}, nn = `
<script>
window.oc = window.console;
function initIframe() {
  var pushToConsole = (payload, type) => {
    window.parent.postMessage({
      console: {
        data: type === 'error' ? [payload] : JSON.parse(JSON.stringify(payload)),
        method: type
      }
    }, "*")
  }

  window.onerror = (message, url, line, column) => {
    pushToConsole('[' + line + ':' + column + '] ' + message, "error")
    // line = line - 70
    // if (line < 0) {
    //   pushToConsole(message, "error")
    // } else {
    //   pushToConsole('[' + line + ':' + column + '] ' + message, "error")
    // }
  }

  var console = (function (systemConsole) {
    return {
      log: function () {
        var args = Array.from(arguments)
        pushToConsole(args, "log")
        systemConsole.log.apply(this, args)
      },

      info: function () {
        var args = Array.from(arguments)
        pushToConsole(args, "info")
        systemConsole.info.apply(this, args)
      },

      warn: function () {
        var args = Array.from(arguments)
        pushToConsole(args, "warn")
        systemConsole.warn.apply(this, args)
      },

      error: function () {
        var args = Array.from(arguments)
        pushToConsole(args, "error")
        systemConsole.error.apply(this, args)
      },

      system: function (arg) {
        pushToConsole(arg, "system")
      },

      clear: function () {
        systemConsole.clear.apply(this, {})
      },

      time: function () {
        var args = Array.from(arguments)
        systemConsole.time.apply(this, args)
      },

      assert: function (assertion, label) {
        if (!assertion) {
          pushToConsole(label, "log")
        }

        var args = Array.from(arguments)
        systemConsole.assert.apply(this, args)
      }

    }

  }(window.console))
  
  window.console = { ...window.console, ...console };
}

initIframe();
<\/script>
`, on = (n, t, o) => {
  let s = n || "";
  if (/<html>([\s\S]*)<\/html>/.test(n) || (s = `<html>${s}</html>`), s.includes("<!DOCTYPE html>") || (s = `<!DOCTYPE html>${s}`), /<head>([\s\S]*)<\/head>/.test(n) || (s = s.replace("<html>", "<html><head><title>PythonTip</title></head>")), !/<body>([\s\S]*)<\/body>/.test(n)) {
    const m = s.replace(/<!DOCTYPE([\s\S]*)<\/head>/, "").replace(/<\/html>([\s\S]*)/, "");
    s = s.replace(/<\/head>([\s\S]*)<\/html>/, `</head><body>${m}</body></html>`);
  }
  let i = t || "";
  /<style>([\s\S]*)<\/style>/.test(i) || (i = `<style>${i}</style>`), s = s.replace("</head>", `${i}</head>`);
  let d = o || "";
  return /<script>([\s\S]*)<\/script>/.test(d) || (d = `<script>${d}<\/script>`), s = s.replace("</body>", `${nn}${d}</body>`), s;
}, cn = "_container_18nvx_1", sn = "_iframeContainer_18nvx_9", ln = "_console_18nvx_17", rn = "_header_18nvx_25", an = "_close_18nvx_34", dn = "_content_18nvx_41", hn = "_line_18nvx_45", un = "_log_18nvx_55", _n = "_info_18nvx_60", mn = "_warn_18nvx_65", pn = "_error_18nvx_70", Cn = "_system_18nvx_75", gn = "_icon_18nvx_80", fn = "_data_18nvx_95", vn = "_item_18nvx_101", yn = "_consoleTag_18nvx_104", q = {
  container: cn,
  iframeContainer: sn,
  console: ln,
  header: rn,
  close: an,
  content: dn,
  line: hn,
  log: un,
  info: _n,
  warn: mn,
  error: pn,
  system: Cn,
  icon: gn,
  data: fn,
  item: vn,
  consoleTag: yn
}, wn = J1(({
  htmlCode: n,
  jsCode: t,
  cssCode: o
}, s) => {
  const r = Y(null), [l, h] = y([]), [i, a] = y(!1), d = () => {
    var N;
    h([]);
    const v = r.current;
    if (!v)
      return;
    v.innerHTML = "";
    const m = document.createElement("iframe");
    (N = r.current) == null || N.prepend(m);
    const u = m.contentWindow, w = u == null ? void 0 : u.document;
    w && (w.open(), w.write(on(n, o, t)), w.close());
  };
  return s && (s.current = { runCode: d }), v1(() => {
    const v = (m) => {
      const { data: u } = m;
      console.log("data", u), u.console && (a(!0), h((w) => [...w, u.console]));
    };
    return window.addEventListener("message", v, !1), () => {
      window.removeEventListener("message", v, !1);
    };
  }, []), /* @__PURE__ */ c("div", { className: q.container, children: [
    /* @__PURE__ */ e("div", { className: q.iframeContainer, ref: r }),
    i ? /* @__PURE__ */ c("div", { className: q.console, children: [
      /* @__PURE__ */ c("div", { className: q.header, children: [
        /* @__PURE__ */ e("span", { children: "Console" }),
        /* @__PURE__ */ e("span", { className: q.close, onClick: () => a(!1), children: "×" })
      ] }),
      /* @__PURE__ */ e("div", { className: q.content, children: l.map(({ method: v, data: m }, u) => /* @__PURE__ */ c("div", { className: f(q.line, q[v]), children: [
        /* @__PURE__ */ e("div", { className: f(q.icon, q[v]) }),
        /* @__PURE__ */ e("div", { className: q.data, children: Array.isArray(m) ? m.map((w, N) => /* @__PURE__ */ e("div", { className: q.item, children: w }, N)) : /* @__PURE__ */ e("div", { className: q.item, children: m }) })
      ] }, u)) })
    ] }) : /* @__PURE__ */ e("div", { className: q.consoleTag, onClick: () => a(!0), children: "console" })
  ] });
}), y2 = ({
  visible: n = !1,
  dataSource: t,
  running: o = !1,
  onClose: s = () => {
  }
}) => {
  const [r, l] = y(""), [h, i] = y(!1), [a, d] = y(t.jsCode), [v, m] = y(t.htmlCode), [u, w] = y(t.cssCode), N = Y(null), D = B(() => [
    {
      code: v,
      language: "html",
      setCode: m
    },
    {
      code: u,
      language: "css",
      setCode: w
    },
    {
      code: a,
      language: "javascript",
      setCode: d
    }
  ], [a, v, u]), E = () => {
    var x;
    (x = N == null ? void 0 : N.current) == null || x.runCode();
  }, V = () => {
    r.trim() && i(!1);
  }, S = () => {
    s();
  };
  return /* @__PURE__ */ e(T, { children: n && /* @__PURE__ */ c("div", { className: Z.container, children: [
    /* @__PURE__ */ c("div", { className: Z.header, children: [
      /* @__PURE__ */ c("div", { className: Z.left, children: [
        /* @__PURE__ */ e("div", { className: Z.close, onClick: S, children: /* @__PURE__ */ e(h1, { style: { width: 24 } }) }),
        /* @__PURE__ */ e("div", { className: Z.title, children: t.title })
      ] }),
      /* @__PURE__ */ e("div", { className: Z.right, children: /* @__PURE__ */ c($, { variant: "filled", onClick: E, children: [
        "运行  ",
        o ? /* @__PURE__ */ e(w1, {}) : /* @__PURE__ */ e(Z1, {})
      ] }) })
    ] }),
    /* @__PURE__ */ c("div", { className: Z.content, children: [
      D.map((x) => /* @__PURE__ */ c("div", { className: Z.code, children: [
        /* @__PURE__ */ e("div", { className: Z["code-header"], children: /* @__PURE__ */ e(K, { language: x.language }) }),
        /* @__PURE__ */ e(
          o1,
          {
            theme: "vs-dark",
            defaultLanguage: s1(x.language),
            defaultValue: x.code,
            height: "calc(100% - 48px)",
            className: Z.editor,
            options: {
              fontSize: Q,
              minimap: {
                enabled: !1
              },
              scrollBeyondLastLine: !1
            },
            onChange: (_) => x.setCode(_ || "")
          }
        ),
        o && /* @__PURE__ */ e("div", { className: Z.running, children: /* @__PURE__ */ e(y1, { type: "code" }) })
      ] }, x.language)),
      /* @__PURE__ */ e("div", { className: Z.output, children: /* @__PURE__ */ e(wn, { ref: N, htmlCode: v, jsCode: a, cssCode: u }) })
    ] }),
    /* @__PURE__ */ c(
      c1,
      {
        visible: h,
        title: "看起来你需要参数输入",
        onClose: () => i(!1),
        children: [
          /* @__PURE__ */ e(
            "textarea",
            {
              className: Z["stdin-input"],
              placeholder: "请输入, 换行可输入多个参数",
              onChange: (x) => l(x.target.value)
            }
          ),
          /* @__PURE__ */ e("div", { className: Z.handler, children: /* @__PURE__ */ e($, { variant: "filled", onClick: V, children: "尝试一下" }) })
        ]
      }
    )
  ] }) });
}, bn = "_container_cnlq3_1", Nn = "_languages_cnlq3_7", xn = "_language_cnlq3_7", kn = "_left_cnlq3_26", Ln = "_right_cnlq3_27", $n = "_running_cnlq3_46", Mn = "_sdtin_cnlq3_60", Vn = "_divider_cnlq3_89", Hn = "_output_cnlq3_93", Bn = "_files_cnlq3_119", L = {
  container: bn,
  languages: Nn,
  language: xn,
  left: kn,
  right: Ln,
  "left-header": "_left-header_cnlq3_32",
  running: $n,
  sdtin: Mn,
  "stdin-input": "_stdin-input_cnlq3_63",
  "sdtin-header": "_sdtin-header_cnlq3_71",
  "sdtin-header-right": "_sdtin-header-right_cnlq3_78",
  divider: Vn,
  output: Hn,
  "output-header": "_output-header_cnlq3_101",
  "output-content": "_output-content_cnlq3_108",
  "output-error": "_output-error_cnlq3_116",
  files: Bn,
  "code-visible-body": "_code-visible-body_cnlq3_125"
}, In = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37256 24 0 18.6274 0 12C0 5.37256 5.37256 0 12 0C18.6274 0 24 5.37256 24 12ZM10.3945 11.7944H13.2798C13.2798 11.7944 14.9014 11.8208 14.9014 10.228V7.59424C14.9014 7.59424 15.1475 6 11.9619 6C8.9126 6 9.10254 7.32178 9.10254 7.32178L9.10645 8.69189H12.0151V9.10352H7.95117C7.95117 9.10352 6 8.88184 6 11.958C6 15.0342 7.70312 14.9248 7.70312 14.9248H8.71924V13.4976C8.71924 13.4976 8.66406 11.7944 10.3945 11.7944ZM10.3574 7.96777C10.2188 7.96777 10.0854 7.91309 9.9873 7.81494C9.93945 7.76709 9.90186 7.71094 9.87598 7.64941C9.86328 7.61914 9.85303 7.58789 9.8457 7.55566C9.83789 7.51953 9.83398 7.48242 9.83398 7.44482C9.83398 7.30566 9.88916 7.17285 9.9873 7.07471C10.0854 6.97656 10.2188 6.92139 10.3574 6.92139C10.4238 6.92139 10.4888 6.93408 10.5493 6.95801C10.582 6.9707 10.6133 6.98682 10.6431 7.00635C10.6733 7.02588 10.7017 7.04883 10.7275 7.07471C10.8257 7.17285 10.8809 7.30566 10.8809 7.44482C10.8809 7.51904 10.8647 7.5918 10.835 7.65869C10.8091 7.71631 10.7729 7.76953 10.7275 7.81494C10.6797 7.86279 10.6235 7.90039 10.5625 7.92627C10.4985 7.95361 10.4287 7.96777 10.3574 7.96777ZM15.2905 9.02197H16.3066C16.3066 9.02197 18.0098 8.91309 18.0098 11.9893C18.0098 15.0654 16.0586 14.8438 16.0586 14.8438H11.9937V15.2554H14.9023L14.9062 16.6245C14.9062 16.6245 15.0962 17.9468 12.0479 17.9468C8.8623 17.9468 9.1084 16.3525 9.1084 16.3525V13.7188C9.1084 12.1255 10.73 12.1519 10.73 12.1519H13.6152C15.3457 12.1519 15.2905 10.4492 15.2905 10.4492V9.02197ZM14.0225 16.1328C13.9243 16.0347 13.791 15.9795 13.6523 15.9795C13.5137 15.9795 13.3804 16.0347 13.2822 16.1328C13.1841 16.231 13.1289 16.3638 13.1289 16.5024C13.1289 16.6416 13.1841 16.7744 13.2822 16.8726C13.3804 16.9707 13.5137 17.0259 13.6523 17.0259C13.791 17.0259 13.9243 16.9707 14.0225 16.8726C14.0615 16.8335 14.0938 16.7891 14.1187 16.7407C14.1558 16.6675 14.1758 16.5859 14.1758 16.5024C14.1758 16.3638 14.1206 16.231 14.0225 16.1328Z",
        fill: "#D9D9D9"
      }
    )
  }
), Zn = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "12", fill: "#575BFD" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M10.3898 11.7952H13.2751C13.2751 11.7952 14.8964 11.8212 14.8964 10.2285V7.59449C14.8964 7.59449 15.1424 6.00049 11.9571 6.00049C8.90778 6.00049 9.09778 7.32249 9.09778 7.32249L9.10178 8.69249H12.0104V9.10382H7.94645C7.94645 9.10382 5.99512 8.88249 5.99512 11.9585C5.99512 15.0345 7.69845 14.9252 7.69845 14.9252H8.71445V13.4978C8.71445 13.4978 8.65912 11.7952 10.3898 11.7952ZM10.3525 7.96849C10.2137 7.96849 10.0805 7.91335 9.9824 7.81521C9.88425 7.71706 9.82912 7.58395 9.82912 7.44515C9.82912 7.30636 9.88425 7.17325 9.9824 7.0751C10.0805 6.97696 10.2137 6.92182 10.3525 6.92182C10.4912 6.92182 10.6244 6.97696 10.7225 7.0751C10.8206 7.17325 10.8758 7.30636 10.8758 7.44515C10.8758 7.58395 10.8206 7.71706 10.7225 7.81521C10.6244 7.91335 10.4912 7.96849 10.3525 7.96849Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M16.3015 9.02245H15.2855V10.4498C15.2855 10.4498 15.3409 12.1524 13.6102 12.1524H10.7249C10.7249 12.1524 9.10352 12.1258 9.10352 13.7191V16.3531C9.10352 16.3531 8.85752 17.9471 12.0429 17.9471C15.0915 17.9471 14.9015 16.6251 14.9015 16.6251L14.8975 15.2558H11.9889V14.8444H16.0535C16.0535 14.8444 18.0049 15.0658 18.0049 11.9898C18.0049 8.91378 16.3015 9.02245 16.3015 9.02245ZM13.6475 15.9798C13.7863 15.9798 13.9194 16.0349 14.0176 16.1331C14.1157 16.2312 14.1709 16.3643 14.1709 16.5031C14.1709 16.6419 14.1157 16.775 14.0176 16.8732C13.9194 16.9713 13.7863 17.0264 13.6475 17.0264C13.5087 17.0264 13.3756 16.9713 13.2775 16.8732C13.1793 16.775 13.1242 16.6419 13.1242 16.5031C13.1242 16.3643 13.1793 16.2312 13.2775 16.1331C13.3756 16.0349 13.5087 15.9798 13.6475 15.9798Z",
          fill: "white"
        }
      )
    ]
  }
), qn = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
          fill: "#D5D5D5"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M13.0836 11.107C13.9192 12.0314 12.8525 12.9026 12.8525 12.9026C12.8525 12.9026 14.9325 11.8359 13.9903 10.4848C13.1014 9.24033 12.408 8.61811 16.1236 6.44922C16.1236 6.467 10.2925 7.94255 13.0836 11.107Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M13.99 3C13.99 3 15.75 4.76 12.3189 7.48C9.5811 9.66667 11.6967 10.9111 12.3189 12.3511C10.7011 10.8933 9.54554 9.61333 10.3278 8.42222C11.4478 6.66222 14.7011 5.80889 13.99 3Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M15.9099 16.0671C19.0921 14.4138 17.6166 12.796 16.6032 13.0271C16.3366 13.0804 16.2299 13.116 16.2299 13.116C16.2299 13.116 16.3188 12.9738 16.5143 12.9204C18.5588 12.2093 20.1232 15.0182 15.8566 16.156C15.8388 16.156 15.8921 16.1027 15.9099 16.0671ZM10.0432 16.7427C10.0432 16.7427 9.38546 17.116 10.5055 17.2582C11.8388 17.4004 12.5499 17.4004 14.0255 17.116C14.0255 17.116 14.4343 17.3827 14.9499 17.5782C11.6255 18.9827 7.4299 17.4893 10.0432 16.7427ZM9.63435 14.8938C9.63435 14.8938 8.88768 15.4449 10.0432 15.5516C11.4832 15.6938 12.6388 15.7293 14.5766 15.3204C14.5766 15.3204 14.861 15.6049 15.2877 15.7471C11.2699 16.9382 6.77212 15.836 9.63435 14.8938Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M17.4742 18.1292C17.4742 18.1292 17.9542 18.5381 16.9231 18.8403C14.9853 19.4447 8.92312 19.6225 7.23424 18.8759C6.62979 18.6092 7.78535 18.2536 8.12312 18.1647C8.49646 18.0759 8.72757 18.1114 8.72757 18.1114C8.05201 17.6136 4.35424 19.0181 6.8609 19.427C13.6342 20.5114 19.2342 18.9292 17.4742 18.1292ZM10.3453 12.9559C10.3453 12.9559 7.25201 13.7025 9.24312 13.9336C10.0965 14.0403 11.7853 14.0225 13.332 13.8803C14.612 13.7736 15.892 13.5425 15.892 13.5425C15.892 13.5425 15.4298 13.7381 15.1098 13.9692C11.9631 14.8047 5.9009 14.4314 7.64312 13.5603C9.17201 12.867 10.3453 12.9559 10.3453 12.9559Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M10.6653 20.5474C13.7231 20.7429 18.4164 20.4407 18.5409 18.9829C18.5409 18.9829 18.3098 19.534 15.9987 19.9607C13.3853 20.4407 10.1498 20.3874 8.24756 20.0674C8.28311 20.0851 8.67423 20.4229 10.6653 20.5474Z",
          fill: "white"
        }
      )
    ]
  }
), Dn = () => /* @__PURE__ */ c(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
          fill: "#575BFD"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M13.0836 11.107C13.9192 12.0314 12.8525 12.9026 12.8525 12.9026C12.8525 12.9026 14.9325 11.8359 13.9903 10.4848C13.1014 9.24033 12.408 8.61811 16.1236 6.44922C16.1236 6.467 10.2925 7.94255 13.0836 11.107Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M13.99 3C13.99 3 15.75 4.76 12.3189 7.48C9.5811 9.66667 11.6967 10.9111 12.3189 12.3511C10.7011 10.8933 9.54554 9.61333 10.3278 8.42222C11.4478 6.66222 14.7011 5.80889 13.99 3Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M15.9099 16.0671C19.0921 14.4138 17.6166 12.796 16.6032 13.0271C16.3366 13.0804 16.2299 13.116 16.2299 13.116C16.2299 13.116 16.3188 12.9738 16.5143 12.9204C18.5588 12.2093 20.1232 15.0182 15.8566 16.156C15.8388 16.156 15.8921 16.1027 15.9099 16.0671ZM10.0432 16.7427C10.0432 16.7427 9.38546 17.116 10.5055 17.2582C11.8388 17.4004 12.5499 17.4004 14.0255 17.116C14.0255 17.116 14.4343 17.3827 14.9499 17.5782C11.6255 18.9827 7.4299 17.4893 10.0432 16.7427ZM9.63435 14.8938C9.63435 14.8938 8.88768 15.4449 10.0432 15.5516C11.4832 15.6938 12.6388 15.7293 14.5766 15.3204C14.5766 15.3204 14.861 15.6049 15.2877 15.7471C11.2699 16.9382 6.77212 15.836 9.63435 14.8938Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M17.4742 18.1292C17.4742 18.1292 17.9542 18.5381 16.9231 18.8403C14.9853 19.4447 8.92312 19.6225 7.23424 18.8759C6.62979 18.6092 7.78535 18.2536 8.12312 18.1647C8.49646 18.0759 8.72757 18.1114 8.72757 18.1114C8.05201 17.6136 4.35424 19.0181 6.8609 19.427C13.6342 20.5114 19.2342 18.9292 17.4742 18.1292ZM10.3453 12.9559C10.3453 12.9559 7.25201 13.7025 9.24312 13.9336C10.0965 14.0403 11.7853 14.0225 13.332 13.8803C14.612 13.7736 15.892 13.5425 15.892 13.5425C15.892 13.5425 15.4298 13.7381 15.1098 13.9692C11.9631 14.8047 5.9009 14.4314 7.64312 13.5603C9.17201 12.867 10.3453 12.9559 10.3453 12.9559Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M10.6653 20.5474C13.7231 20.7429 18.4164 20.4407 18.5409 18.9829C18.5409 18.9829 18.3098 19.534 15.9987 19.9607C13.3853 20.4407 10.1498 20.3874 8.24756 20.0674C8.28311 20.0851 8.67423 20.4229 10.6653 20.5474Z",
          fill: "white"
        }
      )
    ]
  }
), Sn = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM14.3585 9.67053L17.2672 9.1455C16.9172 7.94842 16.3397 7.05936 15.5346 6.47833C14.7366 5.89029 13.6585 5.59627 12.3004 5.59627C10.6413 5.59627 9.32521 6.1108 8.35215 7.13987C7.37909 8.16193 6.89256 9.59353 6.89256 11.4346C6.89256 13.2548 7.37559 14.6794 8.34165 15.7084C9.31471 16.7375 10.6168 17.252 12.2479 17.252C13.683 17.252 14.8276 16.9125 15.6816 16.2335C16.5357 15.5544 17.1132 14.5498 17.4142 13.2198L14.516 12.7262C14.369 13.5033 14.117 14.0528 13.76 14.3748C13.403 14.6899 12.9444 14.8474 12.3844 14.8474C11.6354 14.8474 11.0368 14.5743 10.5888 14.0283C10.1478 13.4823 9.92725 12.5477 9.92725 11.2246C9.92725 10.0346 10.1443 9.1875 10.5783 8.68347C11.0193 8.17243 11.6074 7.91692 12.3424 7.91692C12.8954 7.91692 13.3435 8.06393 13.6865 8.35795C14.0365 8.65197 14.2605 9.08949 14.3585 9.67053Z",
        fill: "#D9D9D9"
      }
    )
  }
), Tn = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM14.3585 9.67053L17.2672 9.1455C16.9172 7.94842 16.3397 7.05936 15.5346 6.47833C14.7366 5.89029 13.6585 5.59627 12.3004 5.59627C10.6413 5.59627 9.32521 6.1108 8.35215 7.13987C7.37909 8.16193 6.89256 9.59353 6.89256 11.4346C6.89256 13.2548 7.37559 14.6794 8.34165 15.7084C9.31471 16.7375 10.6168 17.252 12.2479 17.252C13.683 17.252 14.8276 16.9125 15.6816 16.2335C16.5357 15.5544 17.1132 14.5498 17.4142 13.2198L14.516 12.7262C14.369 13.5033 14.117 14.0528 13.76 14.3748C13.403 14.6899 12.9444 14.8474 12.3844 14.8474C11.6354 14.8474 11.0368 14.5743 10.5888 14.0283C10.1478 13.4823 9.92725 12.5477 9.92725 11.2246C9.92725 10.0346 10.1443 9.1875 10.5783 8.68347C11.0193 8.17243 11.6074 7.91692 12.3424 7.91692C12.8954 7.91692 13.3435 8.06393 13.6865 8.35795C14.0365 8.65197 14.2605 9.08949 14.3585 9.67053Z",
        fill: "#575BFD"
      }
    )
  }
), En = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.95295 13.733L8.50062 13.2725C8.3758 13.8156 8.17001 14.2137 7.88326 14.4667C7.5965 14.7197 7.25408 14.8462 6.856 14.8462C6.31623 14.8462 5.87766 14.6472 5.54031 14.2491C5.20295 13.851 5.03427 13.1831 5.03427 12.2452C5.03427 11.3613 5.20463 10.722 5.54537 10.3273C5.88947 9.93262 6.33647 9.73526 6.88636 9.73526C7.28445 9.73526 7.6218 9.84659 7.89844 10.0692C8.17844 10.2919 8.3623 10.5955 8.45002 10.9801L9.93271 10.6259C9.76403 10.0321 9.51101 9.5767 9.17365 9.25959C8.60689 8.72319 7.86976 8.45499 6.96227 8.45499C5.92321 8.45499 5.08487 8.79741 4.44727 9.48224C3.80966 10.1637 3.49086 11.1218 3.49086 12.3565C3.49086 13.5238 3.80797 14.4448 4.44221 15.1195C5.07644 15.7908 5.8861 16.1265 6.87118 16.1265C7.66735 16.1265 8.32351 15.9308 8.83967 15.5395C9.3592 15.1448 9.73029 14.5426 9.95295 13.733ZM12.3445 13.0043V14.9323H13.6399V13.0043H15.5882V11.6734H13.6399V9.74538H12.3445V11.6734H10.4013V13.0043H12.3445ZM17.8785 13.0043V14.9323H19.174V13.0043H21.1222V11.6734H19.174V9.74538H17.8785V11.6734H15.9353V13.0043H17.8785Z",
        fill: "#D9D9D9"
      }
    )
  }
), Rn = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.95295 13.733L8.50062 13.2725C8.3758 13.8156 8.17001 14.2137 7.88326 14.4667C7.5965 14.7197 7.25408 14.8462 6.856 14.8462C6.31623 14.8462 5.87766 14.6472 5.54031 14.2491C5.20295 13.851 5.03427 13.1831 5.03427 12.2452C5.03427 11.3613 5.20463 10.722 5.54537 10.3273C5.88947 9.93262 6.33647 9.73526 6.88636 9.73526C7.28445 9.73526 7.6218 9.84659 7.89844 10.0692C8.17844 10.2919 8.3623 10.5955 8.45002 10.9801L9.93271 10.6259C9.76403 10.0321 9.51101 9.5767 9.17365 9.25959C8.60689 8.72319 7.86976 8.45499 6.96227 8.45499C5.92321 8.45499 5.08487 8.79741 4.44727 9.48224C3.80966 10.1637 3.49086 11.1218 3.49086 12.3565C3.49086 13.5238 3.80797 14.4448 4.44221 15.1195C5.07644 15.7908 5.8861 16.1265 6.87118 16.1265C7.66735 16.1265 8.32351 15.9308 8.83967 15.5395C9.3592 15.1448 9.73029 14.5426 9.95295 13.733ZM12.3445 13.0043V14.9323H13.6399V13.0043H15.5882V11.6734H13.6399V9.74538H12.3445V11.6734H10.4013V13.0043H12.3445ZM17.8785 13.0043V14.9323H19.174V13.0043H21.1222V11.6734H19.174V9.74538H17.8785V11.6734H15.9353V13.0043H17.8785Z",
        fill: "#575BFD"
      }
    )
  }
), zn = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.7869 7.28099H9.0324V12.9133C9.0324 13.619 8.95111 14.0849 8.78855 14.3109C8.62598 14.533 8.34843 14.644 7.9559 14.644C7.56733 14.644 7.27789 14.4874 7.08757 14.1741C6.96069 13.9679 6.88734 13.6151 6.86751 13.1155L5.20816 13.3058C5.21213 14.2376 5.44606 14.9453 5.90997 15.429C6.37387 15.9088 7.03602 16.1487 7.89643 16.1487C8.62995 16.1487 9.22073 15.996 9.66878 15.6907C10.1168 15.3815 10.4261 14.9731 10.5966 14.4655C10.7235 14.077 10.7869 13.5219 10.7869 12.8003V7.28099ZM13.3241 12.9965L11.6112 13.163C11.7262 14.1384 12.0791 14.8819 12.6699 15.3934C13.2607 15.9009 14.1072 16.1546 15.2095 16.1546C15.9668 16.1546 16.5992 16.0496 17.1067 15.8394C17.6142 15.6253 18.0068 15.3002 18.2843 14.864C18.5619 14.4279 18.7006 13.96 18.7006 13.4604C18.7006 12.9093 18.5837 12.4474 18.3497 12.0747C18.1198 11.698 17.7986 11.4026 17.3862 11.1885C16.9778 10.9704 16.3454 10.7603 15.489 10.5581C14.6325 10.3558 14.0933 10.1616 13.8713 9.9752C13.6968 9.82849 13.6096 9.65205 13.6096 9.44587C13.6096 9.21987 13.7028 9.03946 13.8891 8.90465C14.1786 8.6945 14.579 8.58943 15.0905 8.58943C15.5861 8.58943 15.9569 8.68856 16.2027 8.88681C16.4525 9.08109 16.615 9.40226 16.6904 9.8503L18.4508 9.77298C18.4231 8.97205 18.1317 8.33171 17.5766 7.85194C17.0254 7.37218 16.2027 7.1323 15.1083 7.1323C14.4383 7.1323 13.8653 7.23341 13.3895 7.43562C12.9177 7.63783 12.5549 7.93323 12.3011 8.3218C12.0513 8.7064 11.9264 9.12074 11.9264 9.56482C11.9264 10.2547 12.1941 10.8396 12.7294 11.3193C13.11 11.6603 13.7721 11.9478 14.7158 12.1817C15.4493 12.3641 15.9192 12.491 16.1254 12.5624C16.4267 12.6694 16.6369 12.7963 16.7558 12.943C16.8787 13.0857 16.9402 13.2602 16.9402 13.4664C16.9402 13.7875 16.7955 14.069 16.506 14.3109C16.2205 14.5488 15.7943 14.6678 15.2273 14.6678C14.692 14.6678 14.2658 14.533 13.9486 14.2633C13.6354 13.9937 13.4272 13.5714 13.3241 12.9965Z",
        fill: "#D9D9D9"
      }
    )
  }
), Fn = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.7869 7.28099H9.0324V12.9133C9.0324 13.619 8.95111 14.0849 8.78855 14.3109C8.62598 14.533 8.34843 14.644 7.9559 14.644C7.56733 14.644 7.27789 14.4874 7.08757 14.1741C6.96069 13.9679 6.88734 13.6151 6.86751 13.1155L5.20816 13.3058C5.21213 14.2376 5.44606 14.9453 5.90997 15.429C6.37387 15.9088 7.03602 16.1487 7.89643 16.1487C8.62995 16.1487 9.22073 15.996 9.66878 15.6907C10.1168 15.3815 10.4261 14.9731 10.5966 14.4655C10.7235 14.077 10.7869 13.5219 10.7869 12.8003V7.28099ZM13.3241 12.9965L11.6112 13.163C11.7262 14.1384 12.0791 14.8819 12.6699 15.3934C13.2607 15.9009 14.1072 16.1546 15.2095 16.1546C15.9668 16.1546 16.5992 16.0496 17.1067 15.8394C17.6142 15.6253 18.0068 15.3002 18.2843 14.864C18.5619 14.4279 18.7006 13.96 18.7006 13.4604C18.7006 12.9093 18.5837 12.4474 18.3497 12.0747C18.1198 11.698 17.7986 11.4026 17.3862 11.1885C16.9778 10.9704 16.3454 10.7603 15.489 10.5581C14.6325 10.3558 14.0933 10.1616 13.8713 9.9752C13.6968 9.82849 13.6096 9.65205 13.6096 9.44587C13.6096 9.21987 13.7028 9.03946 13.8891 8.90465C14.1786 8.6945 14.579 8.58943 15.0905 8.58943C15.5861 8.58943 15.9569 8.68856 16.2027 8.88681C16.4525 9.08109 16.615 9.40226 16.6904 9.8503L18.4508 9.77298C18.4231 8.97205 18.1317 8.33171 17.5766 7.85194C17.0254 7.37218 16.2027 7.1323 15.1083 7.1323C14.4383 7.1323 13.8653 7.23341 13.3895 7.43562C12.9177 7.63783 12.5549 7.93323 12.3011 8.3218C12.0513 8.7064 11.9264 9.12074 11.9264 9.56482C11.9264 10.2547 12.1941 10.8396 12.7294 11.3193C13.11 11.6603 13.7721 11.9478 14.7158 12.1817C15.4493 12.3641 15.9192 12.491 16.1254 12.5624C16.4267 12.6694 16.6369 12.7963 16.7558 12.943C16.8787 13.0857 16.9402 13.2602 16.9402 13.4664C16.9402 13.7875 16.7955 14.069 16.506 14.3109C16.2205 14.5488 15.7943 14.6678 15.2273 14.6678C14.692 14.6678 14.2658 14.533 13.9486 14.2633C13.6354 13.9937 13.4272 13.5714 13.3241 12.9965Z",
        fill: "#575BFD"
      }
    )
  }
), An = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.6548 16.7092C9.93468 16.9446 8.74379 17.1385 7.53905 17.1385C4.5895 17.1385 2.80316 16.2245 2.80316 12.1949C2.80316 8.48372 4.63105 7.25128 7.60828 7.25128C8.53607 7.25128 9.61619 7.37591 10.1978 7.59747V9.4392C9.47771 9.1761 8.60531 9.05147 7.77446 9.05147C5.93272 9.05147 5.10187 9.7577 5.10187 12.1949C5.10187 14.7428 5.79425 15.366 7.67752 15.366C8.06526 15.366 8.38375 15.3521 8.70224 15.2829V13.2058H7.06823V11.4471H10.6548V16.7092ZM21.1285 12.1949C21.1285 16.1138 19.5914 17.1385 16.7665 17.1385C13.9832 17.1385 12.4045 16.1138 12.4045 12.1949C12.4045 8.276 13.9832 7.25128 16.7665 7.25128C19.5914 7.25128 21.1285 8.276 21.1285 12.1949ZM14.6202 12.1949C14.6202 14.5628 15.0079 15.3798 16.7665 15.3798C18.539 15.3798 18.9268 14.5628 18.9268 12.1949C18.9268 9.85463 18.539 8.96838 16.7665 8.96838C15.0079 8.96838 14.6202 9.85463 14.6202 12.1949Z",
        fill: "#D5D5D5"
      }
    )
  }
), Pn = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.6548 16.7092C9.93468 16.9446 8.74379 17.1385 7.53905 17.1385C4.5895 17.1385 2.80316 16.2245 2.80316 12.1949C2.80316 8.48372 4.63105 7.25128 7.60828 7.25128C8.53607 7.25128 9.61619 7.37591 10.1978 7.59747V9.4392C9.47771 9.1761 8.60531 9.05147 7.77446 9.05147C5.93272 9.05147 5.10187 9.7577 5.10187 12.1949C5.10187 14.7428 5.79425 15.366 7.67752 15.366C8.06526 15.366 8.38375 15.3521 8.70224 15.2829V13.2058H7.06823V11.4471H10.6548V16.7092ZM21.1285 12.1949C21.1285 16.1138 19.5914 17.1385 16.7665 17.1385C13.9832 17.1385 12.4045 16.1138 12.4045 12.1949C12.4045 8.276 13.9832 7.25128 16.7665 7.25128C19.5914 7.25128 21.1285 8.276 21.1285 12.1949ZM14.6202 12.1949C14.6202 14.5628 15.0079 15.3798 16.7665 15.3798C18.539 15.3798 18.9268 14.5628 18.9268 12.1949C18.9268 9.85463 18.539 8.96838 16.7665 8.96838C15.0079 8.96838 14.6202 9.85463 14.6202 12.1949Z",
        fill: "#575BFD"
      }
    )
  }
), w2 = ({
  dataSource: n,
  dataResult: t = null,
  running: o = !1,
  onRun: s = () => {
  }
}) => {
  var x;
  const r = [
    {
      name: "python",
      entry_filename: "main.py",
      icon: /* @__PURE__ */ e(In, {}),
      icon_active: /* @__PURE__ */ e(Zn, {}),
      default_code: 'print("Hello, World!")'
    },
    {
      name: "java",
      entry_filename: "main.java",
      icon: /* @__PURE__ */ e(qn, {}),
      icon_active: /* @__PURE__ */ e(Dn, {}),
      default_code: `class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello, World!"); 
    }
}`
    },
    {
      name: "c",
      entry_filename: "main.c",
      icon: /* @__PURE__ */ e(Sn, {}),
      icon_active: /* @__PURE__ */ e(Tn, {}),
      default_code: `#include <stdio.h>

int main() {
   printf("Hello, World!");
   return 0;
}`
    },
    {
      name: "c++",
      entry_filename: "main.cpp",
      icon: /* @__PURE__ */ e(En, {}),
      icon_active: /* @__PURE__ */ e(Rn, {}),
      default_code: `#include <iostream>

int main() {
    std::cout << "Hello World!";
    return 0;
}`
    },
    {
      name: "javascript",
      entry_filename: "index.js",
      icon: /* @__PURE__ */ e(zn, {}),
      icon_active: /* @__PURE__ */ e(Fn, {}),
      default_code: 'console.log("Hello, World!")'
    },
    {
      name: "go",
      entry_filename: "main.go",
      icon: /* @__PURE__ */ e(An, {}),
      icon_active: /* @__PURE__ */ e(Pn, {}),
      default_code: `package main //包名
import "fmt" //导入fmt库

func main(){
    fmt.Println("hello world")
}`
    }
  ], [l, h] = y(n.language), [i, a] = y(n.stdin), [d, v] = y(n.source_code), [m, u] = y({
    [l]: d
  }), [w, N] = y(!1), D = B(() => `//pytutor.py2fun.com/iframe-embed.html#code=${encodeURIComponent(d)}&codeDivHeight=400&codeDivWidth=400&cumulative=false&curInstr=0&heapPrimitives=nevernest&origin=opt-frontend.js&py=3&rawInputLstJSON=%5B%5D&textReferences=false`, [d]), E = (_) => {
    const p = r.find((C) => C.name === _);
    u({ ...m, [l]: d }), h(_), v(m[_] || (p == null ? void 0 : p.default_code) || "");
  }, V = () => {
    var C;
    if (o)
      return;
    const _ = ((C = r.find((H) => H.name === l)) == null ? void 0 : C.entry_filename) || "";
    s({
      stdin: i,
      source_code: d,
      language: l,
      additional_files: "[]",
      entry_filename: _,
      time_limit: 30
    });
  }, S = () => {
    o || (v(""), a(""));
  };
  return /* @__PURE__ */ c("div", { className: L.container, children: [
    /* @__PURE__ */ e("div", { className: L.languages, children: r.map((_) => /* @__PURE__ */ e(
      "div",
      {
        className: L.language,
        onClick: () => E(_.name),
        children: _.name === l ? _.icon_active : _.icon
      },
      _.name
    )) }),
    /* @__PURE__ */ c("div", { className: L.left, children: [
      /* @__PURE__ */ e("div", { className: L["left-header"], children: /* @__PURE__ */ e(K, { language: l }) }),
      /* @__PURE__ */ e(
        o1,
        {
          theme: "vs-dark",
          language: s1(l),
          value: d,
          height: "calc(100% - 48px)",
          className: L.editor,
          options: {
            fontSize: Q,
            minimap: {
              enabled: !1
            },
            scrollBeyondLastLine: !1
          },
          onChange: (_) => v(_ || "")
        }
      ),
      o && /* @__PURE__ */ e("div", { className: L.running, children: /* @__PURE__ */ e(y1, { type: "code" }) })
    ] }),
    /* @__PURE__ */ c("div", { className: L.right, children: [
      /* @__PURE__ */ c("div", { className: L.sdtin, children: [
        /* @__PURE__ */ c("div", { className: L["sdtin-header"], children: [
          "输入",
          /* @__PURE__ */ c("div", { className: L["sdtin-header-right"], children: [
            l === "python" && /* @__PURE__ */ e(
              $,
              {
                color: "red",
                variant: "filled",
                onClick: () => N(!0),
                children: "可视化"
              }
            ),
            /* @__PURE__ */ c($, { variant: "filled", onClick: V, children: [
              "运行",
              o && /* @__PURE__ */ c(T, { children: [
                " ",
                /* @__PURE__ */ e(w1, {})
              ] })
            ] }),
            /* @__PURE__ */ e($, { color: "gray", variant: "filled", onClick: S, children: "重置" })
          ] })
        ] }),
        /* @__PURE__ */ e(
          "textarea",
          {
            className: L["stdin-input"],
            placeholder: "请输入, 换行可输入多个参数",
            onChange: (_) => a(_.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ e("div", { className: L.divider }),
      /* @__PURE__ */ c("div", { className: L.output, children: [
        /* @__PURE__ */ e("div", { className: L["output-header"], children: "输出结果" }),
        /* @__PURE__ */ e("div", { className: L["output-content"], children: !!t && /* @__PURE__ */ c(T, { children: [
          !!t.stderr && /* @__PURE__ */ e("div", { className: L["output-error"], children: t.stderr }),
          !!t.stdout && /* @__PURE__ */ e("div", { className: L["output-normal"], children: t.stdout }),
          /* @__PURE__ */ e("div", { className: L.files, children: (x = t == null ? void 0 : t.files) == null ? void 0 : x.map((_) => /* @__PURE__ */ e(P1, { dataSource: _ }, _.name)) })
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ e(
      c1,
      {
        visible: w,
        title: "代码可视化",
        onClose: () => N(!1),
        children: w && /* @__PURE__ */ e(
          "iframe",
          {
            title: "code",
            src: D,
            width: 1024,
            height: 600,
            frameBorder: "0"
          }
        )
      }
    )
  ] });
}, jn = "_tab_1wixy_1", V1 = {
  "tabs-container": "_tabs-container_1wixy_1",
  tab: jn,
  "tab-active": "_tab-active_1wixy_16"
}, b2 = ({
  value: n = "",
  dataSource: t,
  onChange: o = () => {
  }
}) => {
  var h;
  const [s, r] = y(n || ((h = t[0]) == null ? void 0 : h.value)), l = (i) => {
    r(i);
  };
  return v1(() => {
    o(s);
  }, [s, o]), /* @__PURE__ */ e("div", { className: V1["tabs-container"], children: t.map(({ label: i, value: a }) => /* @__PURE__ */ e(
    "div",
    {
      className: f({
        [V1.tab]: !0,
        [V1["tab-active"]]: s === a
      }),
      onClick: () => l(a),
      children: i
    },
    a
  )) });
}, N2 = () => /* @__PURE__ */ e("div", {}), x2 = (n) => /* @__PURE__ */ c("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...n, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M7 7L17 17",
      stroke: "#6B7F99",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M17 7L7 17",
      stroke: "#6B7F99",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    }
  )
] }), On = "_search_1rprt_1", H1 = {
  search: On,
  "search-icon": "_search-icon_1rprt_9",
  "close-icon": "_close-icon_1rprt_16"
}, Wn = (n) => /* @__PURE__ */ e(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    ...n,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M9.66634 19.0002C4.46634 19.0002 0.333008 14.8668 0.333008 9.66683C0.333008 4.46683 4.46634 0.333496 9.66634 0.333496C14.8663 0.333496 18.9997 4.46683 18.9997 9.66683C18.9997 14.8668 14.8663 19.0002 9.66634 19.0002ZM9.66634 16.3335C13.3997 16.3335 16.333 13.4002 16.333 9.66683C16.333 5.9335 13.3997 3.00016 9.66634 3.00016C5.93301 3.00016 2.99967 5.9335 2.99967 9.66683C2.99967 13.4002 5.93301 16.3335 9.66634 16.3335ZM17.533 16.3335L21.2663 20.0668L19.3997 21.9335L15.6663 18.2002L17.533 16.3335Z",
        fill: "#818181"
      }
    )
  }
), k2 = (n) => {
  const {
    value: t,
    onChange: o = () => {
    },
    onClear: s = () => {
    },
    placeholder: r,
    ...l
  } = n;
  return /* @__PURE__ */ c("div", { className: H1.search, ...l, children: [
    /* @__PURE__ */ e("div", { className: H1["search-icon"], children: /* @__PURE__ */ e(Wn, {}) }),
    /* @__PURE__ */ e(
      "input",
      {
        type: "text",
        value: t,
        onChange: o,
        placeholder: r
      }
    ),
    !!t && /* @__PURE__ */ e("div", { className: H1["close-icon"], onClick: () => s(), children: /* @__PURE__ */ e(h1, {}) })
  ] });
}, Gn = "_beian_tbajv_1", Jn = {
  beian: Gn
}, L2 = ({ className: n, ...t }) => {
  const o = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ c("div", { className: f(Jn.beian, n), ...t, children: [
    "成都六味夸克科技有限责任公司 ©",
    o,
    " py2fun.com. All Rights Reserved.",
    /* @__PURE__ */ e(
      "a",
      {
        href: "https://beian.miit.gov.cn/#/Integrated/index",
        target: "_blank",
        rel: "noreferrer",
        style: { textDecoration: "none" },
        children: "蜀ICP备2020030675号-1"
      }
    )
  ] });
};
export {
  S1 as Alert,
  L2 as BeiAn,
  u2 as Box,
  $ as Button,
  C2 as CoachCard,
  g2 as CoachRun,
  f2 as CodeCard,
  v2 as CodeRun,
  N2 as IconArrowDown,
  A1 as IconArrowLeft,
  h1 as IconClose,
  x2 as IconClose1,
  S9 as IconError,
  Z1 as IconPlay,
  D9 as IconSuccess,
  y2 as JsHtmlRun,
  y1 as Loading,
  O as Markdown,
  c1 as Modal,
  p2 as Note,
  A as Notification,
  _2 as PageFooter,
  w2 as Playground,
  m2 as ProgressBar,
  k2 as Search,
  Ke as SelectList,
  b2 as Tabs,
  s1 as unifyLanguageName
};
//# sourceMappingURL=index.js.map
